// import React, { useState, useEffect } from 'react';
// import { ChevronLeft, ChevronRight, Edit2, Image, List, Plus, Save, X } from 'lucide-react';

// // Reusable Button Component
// const Button = ({ children, onClick, color = "blue", className = "" }) => {
//   const colorClasses = {
//     blue: "bg-blue-600 hover:bg-blue-700 text-white",
//     red: "bg-red-600 hover:bg-red-700 text-white",
//     green: "bg-green-600 hover:bg-green-700 text-white",
//     gray: "bg-gray-200 hover:bg-gray-300 text-gray-800"
//   };

//   return (
//     <button
//       onClick={onClick}
//       className={`px-4 py-2 rounded-md transition-colors ${colorClasses[color]} ${className}`}
//     >
//       {children}
//     </button>
//   );
// };


// // Slide Designs (templates)
// const slideDesigns = [
//   // Design 0: Arch Objectives
//   // Design for Full Image slide
// {
//     name: "Full Image",
//     layout: "full-image",
//     bgColor: "bg-black",
//     titleStyle: "text-white font-bold absolute bottom-8 left-8 text-shadow",
//     subtitleStyle: "text-white absolute bottom-16 left-8 text-shadow",
//     descriptionStyle: "text-white absolute bottom-24 left-8 max-w-md text-shadow",
//     bulletStyle: "text-white"
//   },
//   {
//     name: "Arch Objectives",
//     layout: "arch-objectives",
//     bgColor: "bg-gray-900",
//     titleStyle: "text-white font-bold",
//     subtitleStyle: "text-gray-300 uppercase tracking-wider text-2xl font-bold",
//     descriptionStyle: "text-gray-400",
//     bulletStyle: "text-gray-400"
//   },
//   // Design 1: Modern Split
//   {
//     name: "Modern Split",
//     layout: "split",
//     bgColor: "bg-gradient-to-r from-blue-50 to-blue-100",
//     titleStyle: "text-blue-800 font-bold",
//     subtitleStyle: "text-blue-600",
//     descriptionStyle: "text-gray-700",
//     bulletStyle: "text-gray-700"
//   },
//   // Design 2: Luxury Dark
//   {
//     name: "Luxury Dark",
//     layout: "overlay",
//     bgColor: "bg-gray-900",
//     titleStyle: "text-amber-400 font-bold",
//     subtitleStyle: "text-white",
//     descriptionStyle: "text-gray-300",
//     bulletStyle: "text-gray-300"
//   },
//   // Design 3: Clean & Minimal
//   {
//     name: "Clean & Minimal",
//     layout: "centered",
//     bgColor: "bg-white",
//     titleStyle: "text-gray-800 font-bold",
//     subtitleStyle: "text-gray-600",
//     descriptionStyle: "text-gray-700",
//     bulletStyle: "text-gray-700"
//   },
// // Design 4: Market Knowledge
// {
//     name: "Market Knowledge",
//     layout: "market-knowledge",
//     bgColor: "bg-white",
//     titleStyle: "text-gray-800 font-bold text-6xl",
//     subtitleStyle: "text-gray-600",
//     descriptionStyle: "text-gray-700",
//     bulletStyle: "text-gray-700",
//     featureBoxBg: "bg-slate-100"
//   },
//   // Design 5: Corporate Blue
//   {
//     name: "Corporate Blue",
//     layout: "top-image",
//     bgColor: "bg-blue-800",
//     titleStyle: "text-white font-bold",
//     subtitleStyle: "text-blue-200",
//     descriptionStyle: "text-gray-100",
//     bulletStyle: "text-gray-100"
//   },
//   // Design 6: Warm & Inviting
//   {
//     name: "Warm & Inviting",
//     layout: "centered",
//     bgColor: "bg-gradient-to-r from-amber-50 to-amber-100",
//     titleStyle: "text-amber-800 font-bold",
//     subtitleStyle: "text-amber-600",
//     descriptionStyle: "text-gray-700",
//     bulletStyle: "text-gray-700"
//   },
//   // Design 7: Urban Modern
//  // Design for Mission slide (for slide 7)
// {
//     name: "Mission",
//     layout: "mission",
//     bgColor: "bg-gray-900",
//     titleStyle: "text-white text-7xl font-light",
//     subtitleStyle: "text-white text-2xl",
//     descriptionStyle: "text-white text-xl",
//     circleStyle: "bg-amber-200 text-gray-900 font-bold",
//     quoteStyle: "text-white text-lg italic"
//   },
//   // Design for Expertise slide (for slide 8)
// {
//     name: "Expertise",
//     layout: "expertise",
//     bgColor: "bg-gray-900",
//     titleStyle: "text-white text-7xl font-light",
//     bulletStyle: "text-white text-xl",
//     overlayColor: "bg-gradient-to-r from-gray-500 to-transparent"
//   },
//   // Design 8: Premium Red
//   {
//     name: "Premium Red",
//     layout: "top-image",
//     bgColor: "bg-gradient-to-r from-red-100 to-red-50",
//     titleStyle: "text-red-800 font-bold",
//     subtitleStyle: "text-red-600",
//     descriptionStyle: "text-gray-700",
//     bulletStyle: "text-gray-700"
//   },
//   // Design 9: Coastal
//   {
//     name: "Coastal",
//     layout: "split",
//     bgColor: "bg-gradient-to-r from-cyan-50 to-blue-50",
//     titleStyle: "text-cyan-800 font-bold",
//     subtitleStyle: "text-cyan-600",
//     descriptionStyle: "text-gray-700",
//     bulletStyle: "text-gray-700"
//   },
//   // Design 10: Bold & Creative
//   {
//     name: "Bold & Creative",
//     layout: "overlay",
//     bgColor: "bg-purple-900",
//     titleStyle: "text-yellow-400 font-bold",
//     subtitleStyle: "text-purple-200",
//     descriptionStyle: "text-gray-200",
//     bulletStyle: "text-gray-200"
//   },
//   // Design for Contact/Connect slide
// {
//     name: "Contact",
//     layout: "contact",
//     bgColor: "bg-gradient-to-b from-gray-900 to-gray-800",
//     titleStyle: "text-white text-5xl font-light italic",
//     subtitleStyle: "text-white text-2xl",
//     descriptionStyle: "text-white text-lg mt-8 leading-relaxed",
//     bulletStyle: "text-white"
//   }
// ];

// // Main Component
// const SellPage = ({ role }) => {

//   // Default empty slides with different designs



//   const MobileViewMessage = () => {
//     return (
//       <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 text-center shadow-md">
//         <div className="mb-4 flex justify-center">
//           <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
//           </svg>
//         </div>
//         <h3 className="text-xl font-semibold text-gray-800 mb-2">Desktop Experience Recommended</h3>
//         <p className="text-gray-600 mb-4">
//           Our interactive presentation slides are optimized for larger screens. 
//           For the best experience, please view this content on a laptop or desktop device.
//         </p>
//         <div className="text-sm text-gray-500">
//           <p>You can contact me directly for more information:</p>
//           <a href="mailto:BK@BrianKarsh.com" className="text-blue-600 hover:text-blue-800 mt-2 inline-block">
//             BK@BrianKarsh.com
//           </a>
//         </div>
//       </div>
//     );
//   };

//   // Add this style to enable text shadow on the full-image design
// useEffect(() => {
//     // Add text shadow class if it doesn't exist
//     if (!document.getElementById('text-shadow-style')) {
//       const style = document.createElement('style');
//       style.id = 'text-shadow-style';
//       style.innerHTML = `
//         .text-shadow {
//           text-shadow: 0 2px 4px rgba(0,0,0,0.5);
//         }
//       `;
//       document.head.appendChild(style);
//     }
    
//     return () => {
//       // Clean up
//       const style = document.getElementById('text-shadow-style');
//       if (style) style.parentNode.removeChild(style);
//     };
//   }, []);


//   useEffect(() => {
//     const fetchSlides = async () => {
//       try {
//         const response = await fetch('/api/get_sell_slides', {
//           method: 'GET',
//           headers: {
//             'Content-Type': 'application/json',
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         });
//         const slides = await response.json();
  
//         if (response.ok) {
//             if (Array.isArray(slides)) {
//                 setSlides(slides);
//               } else {
//                 setSlides([]); // fallback empty list
//               }
              
//         } else {
//           console.error("Error fetching slides:", slides.message);
//           setSlides(getEmptySlides()); // fallback on error
//         }
//       } catch (error) {
//         console.error("Error fetching slides:", error);
//         setSlides(getEmptySlides()); // fallback on exception
//       }
//     };
  
//     fetchSlides();
//   }, []);
  
  

//   const handleDeleteSlide = (deleteIndex) => {
//     const updatedSlides = slides.filter((_, index) => index !== deleteIndex);
//     setSlides(updatedSlides);
//     if (currentSlide >= updatedSlides.length) {
//       setCurrentSlide(updatedSlides.length - 1);
//     }
//   };
  
  

//   const getEmptySlides = () => {
//     const slides = Array(13).fill().map((_, index) => {
//         // Assign a specific design to each slide index
//         let designIndex;
//         switch(index) {
//           case 0: designIndex = 0; break; // Arch Objectives
//           case 1: designIndex = 1; break; // Modern Split
//           case 2: designIndex = 2; break; // Luxury Dark
//           // ...and so on for each slide
//           default: designIndex = index % slideDesigns.length;
//         }
        
//         return {
//           id: index + 1,
//           title: "",
//           subtitle: "",
//           description: "",
//           image: "",
//           images: [],
//           bulletPoints: [],
//           design: slideDesigns[designIndex]
//         };
//       });
    
//       // Add this at an appropriate point in your getEmptySlides function:
// if (slides.length >= 9) {
//     const contactDesignIndex = slideDesigns.findIndex(d => d.name === "Contact");
//     slides[8].design = slideDesigns[contactDesignIndex];
//     slides[8].title = "Stay In Touch";
//     slides[8].description = "Presentations are communication tools that can be used as demonstrations, lectures, speeches, reports, and more. It is mostly presented before an audience. It serves a variety of purposes, making presentations powerful tools for convincing and teaching.";
//   }

//     // Assign the Market Knowledge design specifically to slide 4
//     if (slides.length >= 4) {
//       slides[3].design = slideDesigns[4]; // Market Knowledge design
//       slides[3].title = "Market Knowledge & Strategy";
//       slides[3].subtitle = "Edge Technology";
//       slides[3].description = "Epic Professional photography, Expert Drone Photos, Online Listing Syndication, Targeted Social Media Campaigns, Email Outreach—Designed to Maximize Exposure, Attract Qualified Buyers Quickly.";
//       slides[3].bulletPoints = [
//         "Proven Record",
//         "Track Record of Securing Favorable Deals on Behalf of Sellers- Higher Sales Prices, Fewer Contingencies, Flexible Closing Timelines, What Ever Works Best For YOU!!"
//       ];

//       if (slides.length >= 8) {
//         const expertiseDesignIndex = slideDesigns.findIndex(d => d.name === "Expertise");
//         slides[7].design = slideDesigns[expertiseDesignIndex];
//         slides[7].title = "MY EXPERTISE";
//         slides[7].bulletPoints = [
//           "Experience & Track Record",
//           "10+ Years of Full-Time Experience",
//           "Over a decade navigating real estate market fluctuations - through both boom times and more challenging cycles.",
//           "200+ Homes Sold",
//           "Proven ability to deliver results consistently, helping hundreds of families and individuals achieve their real estate goals.",
//           "Broad Transaction Variety",
//           "Sales across single-family homes, condominiums, townhomes, and investment properties—gaining firsthand knowledge of virtually every property type."
//         ];
//       }


//       // In the getEmptySlides function, add this after your slide 4 configuration:
// if (slides.length >= 7) {
//     const missionDesignIndex = slideDesigns.findIndex(d => d.name === "Mission");
//     slides[6].design = slideDesigns[missionDesignIndex];
//     slides[6].title = "MY MISSION";
//     slides[6].description = "My goal has always been to help people and put their needs above my own. I don't worry about commissions—I worry about my clients and their success.";
//     slides[6].bulletPoints = [
//       "WHY",
//       "I love real estate for what it has done for my family and for the countless people I've helped. It's amazing to see clients build wealth, transform their futures, and positively impact their families for generations.",
//       "IMPACT",
//       "It's not just about buying or selling a property—it's about helping people create a lasting legacy through real estate. Watching clients build security and wealth for future generations is what drives me every day.",
//       "LEGACY",
//       "Real estate is so much more than a transaction. It's about guiding families toward financial stability, peace of mind, and the freedom to pursue their dreams. That's why I pour my heart into every deal."
//     ];
//   }
//     }
    
//     return slides;
//   };

//   const [slides, setSlides] = useState([]);

//   const [currentSlide, setCurrentSlide] = useState(0);
//   const [editMode, setEditMode] = useState(false);
//   const [editData, setEditData] = useState(null);
//   const [newBulletPoint, setNewBulletPoint] = useState("");
//   const [isUploading, setIsUploading] = useState(false);

//   // Handle Previous Slide
//   const prevSlide = () => {
//     setCurrentSlide(prev => (prev === 0 ? slides.length - 1 : prev - 1));
//   };

//   // Handle Next Slide
//   const nextSlide = () => {
//     setCurrentSlide(prev => (prev === slides.length - 1 ? 0 : prev + 1));
//   };

//   // Enter Edit Mode
//   const handleEdit = () => {
//     // Make sure to initialize images array if it doesn't exist
//     const currentSlideData = {...slides[currentSlide]};
//     if (!currentSlideData.images) {
//       currentSlideData.images = [];
//     }
//     setEditData(currentSlideData);
//     setEditMode(true);
//   };

//   // Close Edit Mode
//   const handleCloseEdit = () => {
//     setEditMode(false);
//     setEditData(null);
//   };

//   // Add Bullet Point
//   const handleAddBulletPoint = () => {
//     if (newBulletPoint.trim()) {
//       setEditData({
//         ...editData,
//         bulletPoints: [...editData.bulletPoints, newBulletPoint.trim()]
//       });
//       setNewBulletPoint("");
//     }
//   };

//   // Remove Bullet Point
//   const handleRemoveBulletPoint = (index) => {
//     setEditData({
//       ...editData,
//       bulletPoints: editData.bulletPoints.filter((_, i) => i !== index)
//     });
//   };



//   // Add this function to your component
// const handleReorderSlides = (startIndex, endIndex) => {
//     const result = [...slides];
//     const [removed] = result.splice(startIndex, 1);
//     result.splice(endIndex, 0, removed);
//     setSlides(result);
    
//     // If the current slide was moved, update currentSlide to follow it
//     if (currentSlide === startIndex) {
//       setCurrentSlide(endIndex);
//     } 
//     // If current slide was shifted due to reordering, adjust its index
//     else if (
//       (startIndex < currentSlide && endIndex >= currentSlide) ||
//       (startIndex > currentSlide && endIndex <= currentSlide)
//     ) {
//       setCurrentSlide(currentSlide + (startIndex < endIndex ? -1 : 1));
//     }
//   };
//   // Handle Image Upload
//   const handleImageUpload = async (e) => {
//     const files = e.target.files;
//     if (!files || files.length === 0) return;
  
//     setIsUploading(true);
//     const uploadedUrls = [];
  
//     // Loop through files and upload each one to Cloudinary
//     for (let i = 0; i < files.length; i++) {
//       const file = files[i];
//       const formData = new FormData();
//       formData.append("file", file);
//       formData.append("upload_preset", "Brian_Karsh"); // Cloudinary preset
  
//       try {
//         const response = await fetch("https://api.cloudinary.com/v1_1/dyglrkcfq/image/upload", {
//           method: "POST",
//           body: formData,
//         });
//         const result = await response.json();
//         if (response.ok) {
//           uploadedUrls.push(result.secure_url);
//         } else {
//           console.error("Error uploading to Cloudinary:", result.message);
//         }
//       } catch (error) {
//         console.error("Error uploading image:", error);
//       }
//     }
  
//     // For designs that expect multiple images (like "arch-objectives"),
//     // merge the new URLs into an array; otherwise, use the first URL.
//     if (editData.design.layout === "arch-objectives") {
//       setEditData({
//         ...editData,
//         images: [...(editData.images || []), ...uploadedUrls],
//       });
//     } else {
//       setEditData({
//         ...editData,
//         image: uploadedUrls[0],
//       });
//     }
  
//     setIsUploading(false);
//   };
  
  

//   // Save Slide Changes
// // Replace your existing handleSaveChanges function
// const handleSaveChanges = async () => {
//   // Check if the edited slide needs pagination
//   const paginatedSlides = splitLongSlideContent(editData);
  
//   // Create updated slides array
//   let updatedSlides = [...slides];
  
//   if (paginatedSlides.length > 1) {
//     // Replace the current slide with the first paginated slide
//     updatedSlides[currentSlide] = paginatedSlides[0];
    
//     // Insert continuation slides after the current slide
//     for (let i = 1; i < paginatedSlides.length; i++) {
//       updatedSlides.splice(currentSlide + i, 0, paginatedSlides[i]);
//     }
    
//     // Show notification to user
//     alert(`Content was split into ${paginatedSlides.length} slides due to length.`);
//   } else {
//     // No pagination needed, update normally
//     updatedSlides[currentSlide] = editData;
//   }
  
//   // Update the slides state
//   setSlides(updatedSlides);
//   setEditMode(false);
//   setEditData(null);

//   console.log("Saving slides with pagination:", updatedSlides);

//   try {
//     const response = await fetch("/api/save_sell_slides", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${localStorage.getItem("token")}`,
//       },
//       body: JSON.stringify({ slides: updatedSlides }),
//     });
    
//     const result = await response.json();
//     if (response.ok) {
//       console.log("Slides saved successfully:", result.message);
//       // Optionally, show a success message
//     } else {
//       console.error("Error saving slides:", result.msg);
//     }
//   } catch (error) {
//     console.error("Error saving slides:", error);
//   }
// };
  

//   // Remove an image from the arch-objectives design
//   const handleRemoveArchImage = (index) => {
//     setEditData({
//       ...editData,
//       images: editData.images.filter((_, i) => i !== index)
//     });
//   };

  

//   // Add a new empty slide 
// const handleAddSlide = (designType = "full-image") => {
//     const designIndex = slideDesigns.findIndex(d => d.name === designType);
//     const newSlide = {
//       id: slides.length + 1,
//       title: "",
//       subtitle: "",
//       description: "",
//       image: "",
//       images: [],
//       bulletPoints: [],
//       design: slideDesigns[designIndex >= 0 ? designIndex : 0]
//     };
    
//     setSlides([...slides, newSlide]);
//     // Optional: navigate to the new slide
//     setCurrentSlide(slides.length);
//   };


//   // Add this before your state declarations
// const getMaxBulletPointsForDesign = (designLayout) => {
//   switch (designLayout) {
//     case "expertise":
//       return 7; // Expertise design can fit about 7 points comfortably
//     case "market-knowledge":
//       return 4; // Market knowledge has limited space
//     case "mission":
//       return 6; // Mission needs pairs of points for each circle
//     case "arch-objectives":
//       return 4; // Arch objectives has limited space for bullet points
//     default:
//       return 6; // Default for most layouts
//   }
// };


// // Add this after the helper function
// const splitLongSlideContent = (slide) => {
//   const maxBulletPoints = getMaxBulletPointsForDesign(slide.design.layout);
  
//   // If the slide doesn't exceed the bullet point limit, return it as is
//   if (!slide.bulletPoints || slide.bulletPoints.length <= maxBulletPoints) {
//     return [slide];
//   }
  
//   // Create an array to hold all paginated slides
//   const paginatedSlides = [];
  
//   // Clone the original slide for the first page
//   const firstSlide = {...slide};
//   firstSlide.bulletPoints = slide.bulletPoints.slice(0, maxBulletPoints);
//   paginatedSlides.push(firstSlide);
  
//   // Create continuation slides with remaining bullet points
//   let remainingPoints = slide.bulletPoints.slice(maxBulletPoints);
//   let pageCount = 2;
  
//   while (remainingPoints.length > 0) {
//     // Create a continuation slide with the same design
//     const continuationSlide = {
//       ...JSON.parse(JSON.stringify(slide)), // Deep clone to avoid reference issues
//       id: slide.id + `-page${pageCount}`,
//       title: `${slide.title} (cont. ${pageCount})`,
//       bulletPoints: remainingPoints.slice(0, maxBulletPoints)
//     };
    
//     paginatedSlides.push(continuationSlide);
//     remainingPoints = remainingPoints.slice(maxBulletPoints);
//     pageCount++;
//   }
  
//   return paginatedSlides;
// };


//   // Render the current slide based on its design
//   const renderSlide = (slide) => {
//     const { design } = slide;
    
//     switch (design.layout) {
//       case "arch-objectives":
//         return (
//           <div className={`flex flex-col h-full ${design.bgColor} relative`}>
//             {/* Logo at top left */}
//             <div className="absolute top-4 left-4 z-10">
//               <div className="text-white text-xs">
//                 <div className="flex items-center">
//                   <div className="mr-2">
//                     <svg width="40" height="30" viewBox="0 0 100 70" fill="none" xmlns="http://www.w3.org/2000/svg">
//                       <path d="M50 0L0 40H20V70H80V40H100L50 0Z" fill="#ffffff" fillOpacity="0.6"/>
//                     </svg>
//                   </div>
//                   <div>
//                     <div className="font-bold tracking-wider">BRIAN</div>
//                     <div className="text-[8px] tracking-wider text-gray-400">REAL ESTATE</div>
//                     <div className="font-bold tracking-wider">KARSH</div>
//                   </div>
//                 </div>
//               </div>
//             </div>
            
//             {/* Main content - 3 arches */}
//             <div className="flex-1 flex flex-col md:flex-row items-stretch p-4 gap-4 mt-12">
//               {/* First arch */}
//               <div className="flex-1 flex flex-col rounded-t-full overflow-hidden border border-gray-700">
//                 <div className="text-center p-4 text-2xl font-light" style={{color:'white'}}>{slide.title || "Objectives"}</div>
//                 <div className="flex-1 overflow-hidden">
//                   {slide.image || (slide.images && slide.images[0]) ? (
//                     <img 
//                       src={slide.image || slide.images[0]} 
//                       alt="Objective 1" 
//                       className="w-full h-full object-cover"
//                     />
//                   ) : (
//                     <div className="w-full h-full bg-gray-800 flex items-center justify-center">
//                       <Image size={48} className="text-gray-600" />
//                     </div>
//                   )}
//                 </div>
//                 <div className="p-6 flex flex-col items-center text-center">
//                   <h3 className={design.subtitleStyle}>{slide.subtitle || "EMPOWER CLIENTS"}</h3>
//                   <p className={design.descriptionStyle + " mt-4"}>
//                     {slide.description || "Provide clear, honest information so they can make the best decisions for their future."}
//                   </p>
//                 </div>
//               </div>
              
//               {/* Second arch */}
//               <div className="flex-1 flex flex-col rounded-t-full overflow-hidden border border-gray-700">
//                 <div className="text-center p-4 text-2xl font-light" style={{color:'white'}}>{slide.title || "Objectives"}</div>

//                 <div className="flex-1 overflow-hidden">
//                   {slide.images && slide.images[1] ? (
//                     <img 
//                       src={slide.images[1]} 
//                       alt="Objective 2" 
//                       className="w-full h-full object-cover"
//                     />
//                   ) : (
//                     <div className="w-full h-full bg-gray-800 flex items-center justify-center">
//                       <Image size={48} className="text-gray-600" />
//                     </div>
//                   )}
//                 </div>
//                 <div className="p-6 flex flex-col items-center text-center">
//                   <h3 className={design.subtitleStyle}>
//                     {slide.bulletPoints && slide.bulletPoints[0] ? slide.bulletPoints[0] : "MAXIMIZE VALUE"}
//                   </h3>
//                   <p className={design.descriptionStyle + " mt-4"}>
//                     {slide.bulletPoints && slide.bulletPoints[1] ? slide.bulletPoints[1] : "Utilize expert negotiation and strategic marketing to help clients build long-term wealth."}
//                   </p>
//                 </div>
//               </div>
              
//               {/* Third arch */}
//               <div className="flex-1 flex flex-col rounded-t-full overflow-hidden border border-gray-700">
//               <div className="text-center p-4 text-2xl font-light" style={{color:'white'}}>{slide.title || "Objectives"}</div>
//               <div className="flex-1 overflow-hidden">
//                   {slide.images && slide.images[2] ? (
//                     <img 
//                       src={slide.images[2]} 
//                       alt="Objective 3" 
//                       className="w-full h-full object-cover"
//                     />
//                   ) : (
//                     <div className="w-full h-full bg-gray-800 flex items-center justify-center">
//                       <Image size={48} className="text-gray-600" />
//                     </div>
//                   )}
//                 </div>
//                 <div className="p-6 flex flex-col items-center text-center">
//                   <h3 className={design.subtitleStyle}>
//                     {slide.bulletPoints && slide.bulletPoints[2] ? slide.bulletPoints[2] : "ENSURE SATISFACTION"}
//                   </h3>
//                   <p className={design.descriptionStyle + " mt-4"}>
//                     {slide.bulletPoints && slide.bulletPoints[3] ? slide.bulletPoints[3] : "Deliver an exceptional experience from the first conversation through closing and beyond."}
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         );
        
//       case "split":
//         return (
//           <div className={`flex flex-col md:flex-row h-full ${design.bgColor}`}>
//             <div className="md:w-1/2 p-8 flex flex-col justify-center">
//               <h2 className={`text-3xl md:text-4xl mb-4 ${design.titleStyle}`}>{slide.title || "Add Your Title"}</h2>
//               <h3 className={`text-xl mb-6 ${design.subtitleStyle}`}>{slide.subtitle || "Add Your Subtitle"}</h3>
//               <p className={`mb-6 ${design.descriptionStyle}`}>{slide.description || "Add your description here..."}</p>
//               {slide.bulletPoints && slide.bulletPoints.length > 0 && (
//                 <ul className="space-y-2">
//                   {slide.bulletPoints.map((point, index) => (
//                     <li key={index} className={`flex items-start ${design.bulletStyle}`}>
//                       <span className="mr-2">•</span>
//                       <span>{point}</span>
//                     </li>
//                   ))}
//                 </ul>
//               )}
//             </div>
//             <div className="md:w-1/2 flex items-center justify-center p-4">
//               {slide.image ? (
//                 <img src={slide.image} alt={slide.title} className="max-h-full object-contain rounded-lg shadow-lg" />
//               ) : (
//                 <div className="w-full h-64 bg-gray-200 rounded-lg flex items-center justify-center">
//                   <Image size={48} className="text-gray-400" />
//                 </div>
//               )}
//             </div>
//           </div>
//         );


//         case "contact":
//   return (
//     <div className={`flex flex-col md:flex-row h-full ${design.bgColor}`}>
//       {/* Left column - Image section with dark background */}
//       <div className="md:w-1/2 bg-black p-8 flex items-center justify-center">
//         {slide.image ? (
//           <img src={slide.image} alt={slide.title} className="max-h-full max-w-full object-contain" />
//         ) : (
//           <div className="w-full h-64 border-2 border-gray-700 rounded-md flex flex-col items-center justify-center">
//             <Image size={64} className="text-gray-700 mb-4" />
//             <p className="text-gray-500">Add your social media or contact graphic here</p>
//           </div>
//         )}
//       </div>
      
//       {/* Right column - Text content */}
//       <div className="md:w-1/2 p-12 flex flex-col justify-center">
//         <h2 className={design.titleStyle}>{slide.title || "Stay In Touch"}</h2>
//         <div className="mt-12">
//           <p className={design.descriptionStyle}>
//             {slide.description || "Presentations are communication tools that can be used as demonstrations, lectures, speeches, reports, and more. It is mostly presented before an audience. It serves a variety of purposes, making presentations powerful tools for convincing and teaching."}
//           </p>
//         </div>
        
//         {/* Brian Karsh logo */}
//         <div className="absolute top-6 right-6">
//           <svg width="180" height="120" viewBox="0 0 180 120" fill="none" xmlns="http://www.w3.org/2000/svg">
//             <path d="M100 20L50 60H70V90H130V60H150L100 20Z" fill="#ffffff" fillOpacity="0.8"/>
//             <text x="100" y="100" textAnchor="middle" className="text-white text-xl">BRIAN</text>
//             <text x="100" y="110" textAnchor="middle" className="text-white text-xs">REAL ESTATE</text>
//             <text x="100" y="120" textAnchor="middle" className="text-white text-xl">KARSH</text>
//           </svg>
//         </div>
//       </div>
//     </div>
//   );

//         case "expertise":
//   return (
//     <div className="relative h-full w-full">
//       {/* Background Image */}
//       {slide.image ? (
//         <div className="absolute inset-0 z-0">
//           <img src={slide.image} alt="" className="w-full h-full object-cover" />
//           <div className="absolute inset-0 bg-black opacity-50"></div>
//         </div>
//       ) : (
//         <div className="absolute inset-0 bg-gradient-to-r from-gray-500 to-gray-900"></div>
//       )}
      
//       {/* Content Overlay */}
//       <div className="relative flex h-full">
//         {/* Left column with content */}
//         <div className="w-2/3 p-10 flex flex-col">
//           {/* Title */}
//           <h1 className={design.titleStyle + " mb-16"}>{slide.title || "MY EXPERTISE"}</h1>
          
//           {/* Bullet Points */}
//           <ul className="space-y-4">
//             {slide.bulletPoints && slide.bulletPoints.length > 0 ? (
//               slide.bulletPoints.map((point, idx) => (
//                 <li key={idx} className="flex items-start">
//                   <span className="mr-3 mt-1.5 text-white">•</span>
//                   <span className={design.bulletStyle}>{point}</span>
//                 </li>
//               ))
//             ) : (
//               <>
//                 <li className="flex items-start">
//                   <span className="mr-3 mt-1.5 text-white">•</span>
//                   <span className={design.bulletStyle}>Experience & Track Record</span>
//                 </li>
//                 <li className="flex items-start">
//                   <span className="mr-3 mt-1.5 text-white">•</span>
//                   <span className={design.bulletStyle}>10+ Years of Full-Time Experience</span>
//                 </li>
//                 <li className="flex items-start">
//                   <span className="mr-3 mt-1.5 text-white">•</span>
//                   <span className={design.bulletStyle}>200+ Homes Sold</span>
//                 </li>
//               </>
//             )}
//           </ul>
//         </div>
        
//         {/* Right column with logo */}
//         <div className="w-1/3 flex items-end justify-center pb-10">
//           <div className="w-40">
//             <svg width="100%" viewBox="0 0 180 120" fill="none" xmlns="http://www.w3.org/2000/svg">
//               <path d="M100 20L50 60H70V90H130V60H150L100 20Z" fill="#ffffff" fillOpacity="0.8"/>
//               <text x="100" y="100" textAnchor="middle" className="text-white text-xl">BRIAN</text>
//               <text x="100" y="110" textAnchor="middle" className="text-white text-xs">REAL ESTATE</text>
//               <text x="100" y="120" textAnchor="middle" className="text-white text-xl">KARSH</text>
//             </svg>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
        
//       case "split-reverse":
//         return (
//           <div className={`flex flex-col md:flex-row h-full ${design.bgColor}`}>
//             <div className="md:w-1/2 flex items-center justify-center p-4 order-1 md:order-0">
//               {slide.image ? (
//                 <img src={slide.image} alt={slide.title} className="max-h-full object-contain rounded-lg shadow-lg" />
//               ) : (
//                 <div className="w-full h-64 bg-gray-200 rounded-lg flex items-center justify-center">
//                   <Image size={48} className="text-gray-400" />
//                 </div>
//               )}
//             </div>
//             <div className="md:w-1/2 p-8 flex flex-col justify-center order-0 md:order-1">
//               <h2 className={`text-3xl md:text-4xl mb-4 ${design.titleStyle}`}>{slide.title || "Add Your Title"}</h2>
//               <h3 className={`text-xl mb-6 ${design.subtitleStyle}`}>{slide.subtitle || "Add Your Subtitle"}</h3>
//               <p className={`mb-6 ${design.descriptionStyle}`}>{slide.description || "Add your description here..."}</p>
//               {slide.bulletPoints && slide.bulletPoints.length > 0 && (
//                 <ul className="space-y-2">
//                   {slide.bulletPoints.map((point, index) => (
//                     <li key={index} className={`flex items-start ${design.bulletStyle}`}>
//                       <span className="mr-2">•</span>
//                       <span>{point}</span>
//                     </li>
//                   ))}
//                 </ul>
//               )}
//             </div>
//           </div>
//         );
        
//       case "centered":
//         return (
//           <div className={`flex flex-col items-center justify-center h-full p-8 text-center ${design.bgColor}`}>
//             <h2 className={`text-3xl md:text-5xl mb-4 ${design.titleStyle}`}>{slide.title || "Add Your Title"}</h2>
//             <h3 className={`text-xl md:text-2xl mb-6 ${design.subtitleStyle}`}>{slide.subtitle || "Add Your Subtitle"}</h3>
//             {slide.image ? (
//               <div className="my-6">
//                 <img src={slide.image} alt={slide.title} className="max-h-64 object-contain rounded-lg shadow-lg mx-auto" />
//               </div>
//             ) : (
//               <div className="w-full max-w-lg h-48 bg-gray-200 rounded-lg flex items-center justify-center mx-auto my-6">
//                 <Image size={48} className="text-gray-400" />
//               </div>
//             )}
//             <p className={`max-w-2xl mb-6 ${design.descriptionStyle}`}>{slide.description || "Add your description here..."}</p>
//             {slide.bulletPoints && slide.bulletPoints.length > 0 && (
//               <ul className="space-y-2 text-left max-w-2xl mx-auto">
//                 {slide.bulletPoints.map((point, index) => (
//                   <li key={index} className={`flex items-start ${design.bulletStyle}`}>
//                     <span className="mr-2">•</span>
//                     <span>{point}</span>
//                   </li>
//                 ))}
//               </ul>
//             )}
//           </div>
//         );


//         case "mission":
//   return (
//     <div className={`flex h-full ${design.bgColor} relative`}>
//       {/* Left section - Image, Title and Description */}
//       <div className="w-1/2 flex flex-col p-8">
//         {/* Title */}
//         <div className="mb-8">
//           <h1 className={design.titleStyle}>{slide.title || "MY MISSION"}</h1>
//         </div>
        
//         {/* Main quote */}
//         <div className="mt-4 mb-8">
//           <p className="text-xl text-white">
//             {slide.description || "My goal has always been to help people and put their needs above my own. I don't worry about commissions—I worry about my clients and their success."}
//           </p>
//         </div>
        
//         {/* Image */}
//         <div className="flex-1 mt-auto">
//           {slide.image ? (
//             <img src={slide.image} alt={slide.title} className="w-2/3 h-full object-cover" />
//           ) : (
//             <div className="w-full h-64 opacity-50">
//               <Image size={64} className="text-gray-400" />
//             </div>
//           )}
//         </div>
        
//         {/* Brian Karsh logo */}
//         <div className="absolute top-6 right-12">
//           <svg width="180" height="120" viewBox="0 0 180 120" fill="none" xmlns="http://www.w3.org/2000/svg">
//             <path d="M100 20L50 60H70V90H130V60H150L100 20Z" fill="#ffffff" fillOpacity="0.8"/>
//             <text x="100" y="100" textAnchor="middle" className="text-white text-xl">BRIAN</text>
//             <text x="100" y="110" textAnchor="middle" className="text-white text-xs">REAL ESTATE</text>
//             <text x="100" y="120" textAnchor="middle" className="text-white text-xl">KARSH</text>
//           </svg>
//         </div>
//       </div>
      
//       {/* Right section - Three circles with descriptions */}
//       <div className="w-1/2 p-8 flex flex-col justify-center space-y-16">
//         {/* WHY Circle */}
//         <div className="flex items-center space-x-4">
//           <div className="w-28 h-28 rounded-full flex items-center justify-center text-2xl flex-shrink-0" 
//                style={{backgroundColor: '#E5C9B1'}}>
//             <span className="font-bold text-gray-900">WHY</span>
//           </div>
//           <p className="text-white">
//             {slide.bulletPoints && slide.bulletPoints[1] ? slide.bulletPoints[1] : 
//             "I love real estate for what it has done for my family and for the countless people I've helped. It's amazing to see clients build wealth, transform their futures, and positively impact their families for generations."}
//           </p>
//         </div>
        
//         {/* IMPACT Circle */}
//         <div className="flex items-center space-x-4">
//           <div className="w-28 h-28 rounded-full flex items-center justify-center text-2xl flex-shrink-0"
//                style={{backgroundColor: '#E5C9B1'}}>
//             <span className="font-bold text-gray-900">IMPACT</span>
//           </div>
//           <p className="text-white">
//             {slide.bulletPoints && slide.bulletPoints[3] ? slide.bulletPoints[3] : 
//             "It's not just about buying or selling a property—it's about helping people create a lasting legacy through real estate. Watching clients build security and wealth for future generations is what drives me every day."}
//           </p>
//         </div>
        
//         {/* LEGACY Circle */}
//         <div className="flex items-center space-x-4">
//           <div className="w-28 h-28 rounded-full flex items-center justify-center text-2xl flex-shrink-0"
//                style={{backgroundColor: '#E5C9B1'}}>
//             <span className="font-bold text-gray-900">LEGACY</span>
//           </div>
//           <p className="text-white">
//             {slide.bulletPoints && slide.bulletPoints[5] ? slide.bulletPoints[5] : 
//             "Real estate is so much more than a transaction. It's about guiding families toward financial stability, peace of mind, and the freedom to pursue their dreams. That's why I pour my heart into every deal."}
//           </p>
//         </div>
//       </div>
//     </div>
//   );
        
//       case "overlay":
//         return (
//           <div className={`relative h-full flex items-center justify-center ${design.bgColor}`}>
//             {slide.image ? (
//               <div className="absolute inset-0">
//                 <div className="absolute inset-0 bg-black opacity-40"></div>
//                 <img src={slide.image} alt={slide.title} className="w-full h-full object-cover" />
//               </div>
//             ) : (
//               <div className="absolute inset-0 bg-black opacity-10"></div>
//             )}
//             <div className="relative z-10 max-w-3xl p-8 mx-4 bg-black bg-opacity-50 rounded-lg">
//               <h2 className={`text-3xl md:text-4xl mb-4 ${design.titleStyle}`}>{slide.title || "Add Your Title"}</h2>
//               <h3 className={`text-xl mb-6 ${design.subtitleStyle}`}>{slide.subtitle || "Add Your Subtitle"}</h3>
//               <p className={`mb-6 ${design.descriptionStyle}`}>{slide.description || "Add your description here..."}</p>
//               {slide.bulletPoints && slide.bulletPoints.length > 0 && (
//                 <ul className="space-y-2">
//                   {slide.bulletPoints.map((point, index) => (
//                     <li key={index} className={`flex items-start ${design.bulletStyle}`}>
//                       <span className="mr-2">•</span>
//                       <span>{point}</span>
//                     </li>
//                   ))}
//                 </ul>
//               )}
//             </div>
//           </div>
//         );
//         case "market-knowledge":
//   return (
//     <div className={`flex flex-col h-full ${design.bgColor} relative`}>
//       {/* Main content container */}
//       <div className="flex h-full">
//         {/* Left column - Image and Title */}
//         <div className="w-1/2 flex flex-col">
//           {/* Image section */}
//           <div className="h-2/3 overflow-hidden">
//             {slide.image ? (
//               <img src={slide.image} alt={slide.title} className="w-full h-full object-cover" />
//             ) : (
//               <div className="w-full h-full bg-gray-200 flex items-center justify-center">
//                 <Image size={64} className="text-gray-400" />
//               </div>
//             )}
//           </div>
          
//           {/* Title section */}
//           <div className="h-1/3 flex items-center p-8">
//             <h1 className={design.titleStyle}>{slide.title || "Market Knowledge & Strategy"}</h1>
//           </div>
          
//           {/* Brian Karsh logo */}
//           <div className="absolute bottom-6 left-1/4 transform -translate-x-1/2">
//             <svg width="260" height="160" viewBox="0 0 260 180" fill="none" xmlns="http://www.w3.org/2000/svg">
//               <path d="M140 30L90 70H110V100H170V70H190L140 30Z" fill="#D9D9D9" fillOpacity="0.6"/>
//               <text x="130" y="130" textAnchor="middle" className="text-gray-400 text-2xl">BRIAN</text>
//               <text x="130" y="145" textAnchor="middle" className="text-gray-300 text-xs">REAL ESTATE</text>
//               <text x="130" y="160" textAnchor="middle" className="text-gray-400 text-2xl">KARSH</text>
//             </svg>
//           </div>
//         </div>
        
//         {/* Right column - Feature boxes */}
//         <div className="w-1/2 bg-gray-900 p-8 flex flex-col justify-center space-y-8">
//           {/* Feature box 1 */}
//           <div className="space-y-4">
//             <div className="flex items-center space-x-4">
//               <div className="w-10 h-10 flex items-center justify-center">
//                 <svg viewBox="0 0 24 24" width="24" height="24" className="text-gray-100">
//                   <circle cx="12" cy="12" r="11" stroke="currentColor" fill="none" strokeWidth="2"/>
//                   <path d="M7 12 L11 16 L17 8" stroke="currentColor" strokeWidth="2" fill="none"/>
//                 </svg>
//               </div>
//               <div className={`${design.featureBoxBg} px-8 py-2 rounded-md`}>
//                 <h3 className="text-3xl font-bold">{slide.subtitle || "Edge Technology"}</h3>
//               </div>
//             </div>
//             <p className="text-gray-300 pl-14">
//               {slide.description || "Epic Professional photography, Expert Drone Photos, Online Listing Syndication, Targeted Social Media Campaigns, Email Outreach—Designed to Maximize Exposure, Attract Qualified Buyers Quickly."}
//             </p>
//           </div>
          
//           {/* Feature box 2 */}
//           <div className="space-y-4">
//             <div className="flex items-center space-x-4">
//               <div className="w-10 h-10 flex items-center justify-center">
//                 <svg viewBox="0 0 24 24" width="24" height="24" className="text-gray-100">
//                   <circle cx="12" cy="12" r="11" stroke="currentColor" fill="none" strokeWidth="2"/>
//                   <circle cx="12" cy="12" r="5" stroke="currentColor" fill="none" strokeWidth="2"/>
//                   <circle cx="12" cy="12" r="2" fill="currentColor"/>
//                 </svg>
//               </div>
//               <div className={`${design.featureBoxBg} px-8 py-2 rounded-md`}>
//                 <h3 className="text-3xl font-bold">
//                   {slide.bulletPoints && slide.bulletPoints[0] 
//                     ? slide.bulletPoints[0] 
//                     : "Proven Record"}
//                 </h3>
//               </div>
//             </div>
//             <p className="text-gray-300 pl-14">
//               {slide.bulletPoints && slide.bulletPoints[1] 
//                 ? slide.bulletPoints[1] 
//                 : "Track Record of Securing Favorable Deals on Behalf of Sellers- Higher Sales Prices, Fewer Contingencies, Flexible Closing Timelines, What Ever Works Best For YOU!!"}
//             </p>
//           </div>
//         </div>
//       </div>
//     </div>
//   );


//   case "full-image":
//   return (
//     <div className="relative h-full w-full bg-black">
//       {/* Full-size Image */}
//       {slide.image ? (
//         <div className="absolute inset-0">
//           <img 
//             src={slide.image} 
//             alt={slide.title} 
//             className="w-full h-full object-contain" 
//           />
//         </div>
//       ) : (
//         <div className="w-full h-full flex flex-col items-center justify-center">
//           <Image size={96} className="text-gray-700 mb-4" />
//           <p className="text-gray-500 text-lg">Upload an image to display here</p>
//         </div>
//       )}
      
//       {/* Optional overlay text */}
//       {(slide.title || slide.subtitle || slide.description) && (
//         <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent">
//           {slide.subtitle && (
//             <h3 className={design.subtitleStyle}>{slide.subtitle}</h3>
//           )}
//           {slide.title && (
//             <h2 className={design.titleStyle}>{slide.title}</h2>
//           )}
//           {slide.description && (
//             <p className={design.descriptionStyle}>{slide.description}</p>
//           )}
//         </div>
//       )}
//     </div>
//   );
        
//       case "top-image":
//         return (
//           <div className={`flex flex-col h-full ${design.bgColor}`}>
//             <div className="h-1/2 overflow-hidden">
//               {slide.image ? (
//                 <img src={slide.image} alt={slide.title} className="w-full h-full object-cover" />
//               ) : (
//                 <div className="w-full h-full bg-gray-300 flex items-center justify-center">
//                   <Image size={64} className="text-gray-500" />
//                 </div>
//               )}
//             </div>
//             <div className="h-1/2 p-8 flex flex-col justify-center">
//               <h2 className={`text-3xl md:text-4xl mb-4 ${design.titleStyle}`}>{slide.title || "Add Your Title"}</h2>
//               <h3 className={`text-xl mb-4 ${design.subtitleStyle}`}>{slide.subtitle || "Add Your Subtitle"}</h3>
//               <p className={`mb-4 ${design.descriptionStyle}`}>{slide.description || "Add your description here..."}</p>
//               {slide.bulletPoints && slide.bulletPoints.length > 0 && (
//                 <ul className="space-y-2">
//                   {slide.bulletPoints.map((point, index) => (
//                     <li key={index} className={`flex items-start ${design.bulletStyle}`}>
//                       <span className="mr-2">•</span>
//                       <span>{point}</span>
//                     </li>
//                   ))}
//                 </ul>
//               )}
//             </div>
//           </div>
//         );
        
//       default:
//         return (
//           <div className="flex items-center justify-center h-full bg-gray-100">
//             <p>Slide layout not found</p>
//           </div>
//         );
//     }
//   };

//   return (
//     <div className="w-full max-w-6xl mx-auto p-4 mt-44">


// <div className="block md:hidden">
//       <MobileViewMessage />
//     </div>
//     <div className="hidden md:block">

//       <div className="bg-white rounded-lg shadow-lg overflow-hidden">
//         {/* Slide Viewer */}
//         <div className="relative h-96 md:h-screen md:max-h-[70vh] overflow-hidden">
//         {slides[currentSlide] ? renderSlide(slides[currentSlide]) : null}

          
//           {/* Navigation Controls */}
//           {/* <div className="absolute bottom-4 left-0 right-0 flex justify-center space-x-4">
//             <Button color="gray" onClick={prevSlide} className="flex items-center">
//               <ChevronLeft size={16} className="mr-1" /> Prev
//             </Button>
//             <span className="px-4 py-2 bg-gray-100 rounded-md text-gray-800">
//               {currentSlide + 1} / {slides.length}
//             </span>
//             <Button color="gray" onClick={nextSlide} className="flex items-center">
//               Next <ChevronRight size={16} className="ml-1" />
//             </Button>
//           </div> */}
          
//           {/* Edit Button */}
//           {role === "owner" && (
//   <button 
//     onClick={handleEdit} 
//     className="absolute top-4 right-4 bg-white rounded-full p-2 shadow-md hover:bg-gray-100"
//   >
//     <Edit2 size={18} className="text-gray-700" />
//   </button>
// )}

//         </div>
        
//        {/* Slide Numbers */}
// <div className="bg-gray-100 p-4 overflow-x-auto">
//   <div className="flex justify-center space-x-2">
//     {slides.map((slide, index) => (
//       <button
//         key={index}
//         onClick={() => setCurrentSlide(index)}
//         className={`w-10 h-10 rounded-full flex items-center justify-center 
//           ${currentSlide === index 
//             ? 'bg-blue-500 text-white font-bold' 
//             : 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-50'
//           } transition-colors`}
//       >
//         {index + 1}
//       </button>
//     ))}
//   </div>
// </div>
//       </div>
      
//       {/* Edit Modal */}
//       {editMode && editData && (
//         <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4 backdrop-blur-sm">
//           <div className="bg-white rounded-lg shadow-xl max-w-3xl w-full max-h-[90vh] overflow-y-auto">
//             <div className="flex justify-between items-center p-4 border-b">
//               <h2 className="text-xl font-bold">Edit Slide {currentSlide + 1}</h2>
//               <button onClick={handleCloseEdit} className="text-gray-500 hover:text-gray-700">
//                 <X size={20} />
//               </button>
//             </div>
            
//             <div className="p-6 space-y-6">
//               {/* Title */}
//               <div>
//                 <label className="block font-medium text-gray-700 mb-2">Title</label>
//                 <input
//                   type="text"
//                   className="w-full border border-gray-300 rounded-md px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                   value={editData.title}
//                   onChange={(e) => setEditData({...editData, title: e.target.value})}
//                   placeholder="Enter slide title"
//                 />
//               </div>
              
//               {/* Subtitle */}
//               <div>
//                 <label className="block font-medium text-gray-700 mb-2">Subtitle</label>
//                 <input
//                   type="text"
//                   className="w-full border border-gray-300 rounded-md px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                   value={editData.subtitle}
//                   onChange={(e) => setEditData({...editData, subtitle: e.target.value})}
//                   placeholder="Enter slide subtitle"
//                 />
//               </div>
              
//               {/* Description */}
//               <div>
//                 <label className="block font-medium text-gray-700 mb-2">Description</label>
//                 <textarea
//                   rows={4}
//                   className="w-full border border-gray-300 rounded-md px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-none"
//                   value={editData.description}
//                   onChange={(e) => setEditData({...editData, description: e.target.value})}
//                   placeholder="Enter slide description"
//                 />
//               </div>
              
//               {/* Image Upload */}
//               <div>
//                 <label className="block font-medium text-gray-700 mb-2">
//                   {editData.design.layout === "arch-objectives" ? "Arch Images (3 recommended)" : "Slide Image"}
//                 </label>
                
//                 {editData.design.layout === "arch-objectives" ? (
//                   <div className="space-y-4">
//                     {/* Display multiple images for arch design */}
//                     {editData.images && editData.images.length > 0 && (
//                       <div className="grid grid-cols-3 gap-2">
//                         {editData.images.map((img, idx) => (
//                           <div key={idx} className="relative">
//                             <img src={img} alt={`Objective ${idx + 1}`} className="w-full h-24 object-cover rounded" />
//                             <button 
//                               onClick={() => handleRemoveArchImage(idx)}
//                               className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-1 hover:bg-red-600"
//                             >
//                               <X size={16} />
//                             </button>
//                             <div className="text-xs text-center mt-1">Arch {idx + 1}</div>
//                           </div>
//                         ))}
//                       </div>
//                     )}
                    
//                     {/* Upload button for arch design */}
//                     <div className="border-2 border-dashed border-gray-300 rounded-md p-4 w-full text-center hover:bg-gray-50 transition duration-150 cursor-pointer">
//                       <input 
//                         type="file" 
//                         accept="image/*" 
//                         onChange={handleImageUpload}
//                         className="hidden" 
//                         id="arch-image-upload"
//                         disabled={isUploading}
//                       />
//                       <label htmlFor="arch-image-upload" className={`cursor-pointer ${isUploading ? 'opacity-50' : ''}`}>
//                         {isUploading ? (
//                           <div className="flex flex-col items-center">
//                             <svg className="animate-spin h-8 w-8 text-blue-500 mb-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
//                               <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
//                               <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
//                             </svg>
//                             <span className="text-sm font-medium text-gray-700">Uploading...</span>
//                           </div>
//                         ) : (
//                           <>
//                             <Image className="mx-auto h-8 w-8 text-gray-400" />
//                             <span className="mt-1 block text-sm font-medium text-gray-700">
//                               Add another arch image
//                             </span>
//                             <span className="text-xs text-gray-500">
//                               {editData.images.length}/3 images uploaded
//                             </span>
//                           </>
//                         )}
//                       </label>
//                     </div>
//                   </div>
//                 ) : (
//                   <div className="mt-2 flex flex-col items-center">
//                     {/* Standard single image for other designs */}
//                     {editData.image ? (
//                       <div className="relative mb-4">
//                         <img src={editData.image} alt="Preview" className="max-h-40 object-contain rounded" />
//                         <button 
//                           onClick={() => setEditData({...editData, image: ""})}
//                           className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-1 hover:bg-red-600"
//                         >
//                           <X size={16} />
//                         </button>
//                       </div>
//                     ) : null}
                    
//                     <div className="border-2 border-dashed border-gray-300 rounded-md p-6 w-full text-center hover:bg-gray-50 transition duration-150 cursor-pointer">
//                       <input 
//                         type="file" 
//                         accept="image/*" 
//                         onChange={handleImageUpload}
//                         className="hidden" 
//                         id="image-upload"
//                         disabled={isUploading}
//                       />
//                       <label htmlFor="image-upload" className={`cursor-pointer ${isUploading ? 'opacity-50' : ''}`}>
//                         {isUploading ? (
//                           <div className="flex flex-col items-center">
//                             <svg className="animate-spin h-8 w-8 text-blue-500 mb-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
//                               <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
//                               <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
//                             </svg>
//                             <span className="text-sm font-medium text-gray-700">Uploading...</span>
//                           </div>
//                         ) : (
//                           <>
//                             <Image className="mx-auto h-12 w-12 text-gray-400" />
//                             <span className="mt-2 block text-sm font-medium text-gray-700">
//                               {editData.image ? "Replace image" : "Click to upload an image"}
//                             </span>
//                           </>
//                         )}
//                       </label>
//                     </div>
//                   </div>
//                 )}
//               </div>
              
//               {/* Bullet Points */}
//               <div>
//                 <label className="block font-medium text-gray-700 mb-2 flex items-center">
//                   <List size={16} className="mr-2" /> 
//                   {editData.design.layout === "arch-objectives" 
//                     ? "Additional Headings & Descriptions (for Arch 2 & 3)" 
//                     : "Bullet Points"}
//                 </label>
//                 {editData.design.layout === "arch-objectives" && (
//                   <div className="mb-4 text-sm text-gray-500">
//                     For Arch Objectives: Add headings and descriptions as bullet points in this order:<br/>
//                     1. Arch 2 Heading, 2. Arch 2 Description, 3. Arch 3 Heading, 4. Arch 3 Description
//                   </div>
//                 )}
                
//                 {/* Current Bullet Points */}
//                 {editData.bulletPoints && editData.bulletPoints.length > 0 ? (
//                   <ul className="mb-4 space-y-2">
//                     {editData.bulletPoints.map((point, index) => (
//                       <li key={index} className="flex items-center bg-gray-50 p-2 rounded-md">
//                         <span className="flex-grow">{point}</span>
//                         <button 
//                           onClick={() => handleRemoveBulletPoint(index)}
//                           className="text-red-500 hover:text-red-700 ml-2"
//                         >
//                           <X size={16} />
//                         </button>
//                       </li>
//                     ))}
//                   </ul>
//                 ) : (
//                   <p className="text-gray-500 italic mb-4">No bullet points added yet.</p>
//                 )}





//                 {/* Add New Bullet Point */}
//                 <div className="flex">
//                   <input
//                     type="text"
//                     className="flex-grow border border-gray-300 rounded-l-md px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                     value={newBulletPoint}
//                     onChange={(e) => setNewBulletPoint(e.target.value)}
//                     placeholder="Add a new bullet point"
//                     onKeyPress={(e) => e.key === 'Enter' && handleAddBulletPoint()}
//                   />
//                   <button
//                     onClick={handleAddBulletPoint}
//                     className="bg-blue-500 text-white px-4 rounded-r-md hover:bg-blue-600 flex items-center"
//                   >
//                     <Plus size={16} className="mr-1" /> Add
//                   </button>
//                 </div>


//                 {/* Draggable Slide Numbers */}
// <div className="bg-gray-100 p-4 overflow-x-auto">
//   <div className="flex justify-center space-x-2">
//     {slides.map((slide, index) => (
//       <button
//         key={index}
//         onClick={() => setCurrentSlide(index)}
//         draggable
//         onDragStart={(e) => {
//           e.dataTransfer.setData('text/plain', index);
//           e.currentTarget.classList.add('opacity-50');
//         }}
//         onDragEnd={(e) => {
//           e.currentTarget.classList.remove('opacity-50');
//         }}
//         onDragOver={(e) => {
//           e.preventDefault();
//         }}
//         onDrop={(e) => {
//           e.preventDefault();
//           const draggedIndex = parseInt(e.dataTransfer.getData('text/plain'));
//           if (draggedIndex !== index) {
//             handleReorderSlides(draggedIndex, index);
//           }
//         }}
//         className={`w-10 h-10 rounded-full flex items-center justify-center cursor-move
//           ${currentSlide === index 
//             ? 'bg-blue-500 text-white font-bold' 
//             : 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-50'
//           } transition-colors`}
//       >
//         {index + 1}
//       </button>
//     ))}
//   </div>
// </div>

//               </div>
//             </div>
            
//             <div className="border-t p-4 flex justify-end space-x-3">
//               <Button color="gray" onClick={handleCloseEdit}>Cancel</Button>
//               <Button onClick={handleSaveChanges} className="flex items-center">
//                 <Save size={16} className="mr-2" /> Save Changes
//               </Button>

//               <button
//   onClick={() => handleAddSlide("Full Image")}
//   className="ml-4 bg-green-500 text-white px-4 py-2 rounded-md hover:bg-green-600 flex items-center"
// >
//   <Plus size={16} className="mr-1" /> Add Image Slide
// </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//     </div>
//   );
// };

// export default SellPage;













import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight, Edit2, Image, List, Plus, Save, X } from 'lucide-react';

// Reusable Button Component
const Button = ({ children, onClick, color = "blue", className = "" }) => {
  const colorClasses = {
    blue: "bg-blue-600 hover:bg-blue-700 text-white",
    red: "bg-red-600 hover:bg-red-700 text-white",
    green: "bg-green-600 hover:bg-green-700 text-white",
    gray: "bg-gray-200 hover:bg-gray-300 text-gray-800"
  };

  return (
    <button
      onClick={onClick}
      className={`px-4 py-2 rounded-md transition-colors ${colorClasses[color]} ${className}`}
    >
      {children}
    </button>
  );
};

const backendUrl = 'https://python-backend-68898252993.us-central1.run.app';


// Slide Designs (templates)
const slideDesigns = [
  // Design 0: Arch Objectives
  // Design for Full Image slide
{
    name: "Full Image",
    layout: "full-image",
    bgColor: "bg-black",
    titleStyle: "text-white font-bold absolute bottom-8 left-8 text-shadow",
    subtitleStyle: "text-white absolute bottom-16 left-8 text-shadow",
    descriptionStyle: "text-white absolute bottom-24 left-8 max-w-md text-shadow",
    bulletStyle: "text-white"
  },
  {
    name: "Arch Objectives",
    layout: "arch-objectives",
    bgColor: "bg-gray-900",
    titleStyle: "text-white font-bold",
    subtitleStyle: "text-gray-300 uppercase tracking-wider text-2xl font-bold",
    descriptionStyle: "text-gray-400",
    bulletStyle: "text-gray-400"
  },
  // Design 1: Modern Split
  {
    name: "Modern Split",
    layout: "split",
    bgColor: "bg-gradient-to-r from-blue-50 to-blue-100",
    titleStyle: "text-blue-800 font-bold",
    subtitleStyle: "text-blue-600",
    descriptionStyle: "text-gray-700",
    bulletStyle: "text-gray-700"
  },
  // Design 2: Luxury Dark
  {
    name: "Luxury Dark",
    layout: "overlay",
    bgColor: "bg-gray-900",
    titleStyle: "text-amber-400 font-bold",
    subtitleStyle: "text-white",
    descriptionStyle: "text-gray-300",
    bulletStyle: "text-gray-300"
  },
  // Design 3: Clean & Minimal
  {
    name: "Clean & Minimal",
    layout: "centered",
    bgColor: "bg-white",
    titleStyle: "text-gray-800 font-bold",
    subtitleStyle: "text-gray-600",
    descriptionStyle: "text-gray-700",
    bulletStyle: "text-gray-700"
  },
// Design 4: Market Knowledge
{
    name: "Market Knowledge",
    layout: "market-knowledge",
    bgColor: "bg-white",
    titleStyle: "text-gray-800 font-bold text-6xl",
    subtitleStyle: "text-gray-600",
    descriptionStyle: "text-gray-700",
    bulletStyle: "text-gray-700",
    featureBoxBg: "bg-slate-100"
  },
  // Design 5: Corporate Blue
  {
    name: "Corporate Blue",
    layout: "top-image",
    bgColor: "bg-blue-800",
    titleStyle: "text-white font-bold",
    subtitleStyle: "text-blue-200",
    descriptionStyle: "text-gray-100",
    bulletStyle: "text-gray-100"
  },
  // Design 6: Warm & Inviting
  {
    name: "Warm & Inviting",
    layout: "centered",
    bgColor: "bg-gradient-to-r from-amber-50 to-amber-100",
    titleStyle: "text-amber-800 font-bold",
    subtitleStyle: "text-amber-600",
    descriptionStyle: "text-gray-700",
    bulletStyle: "text-gray-700"
  },
  // Design 7: Urban Modern
 // Design for Mission slide (for slide 7)
{
    name: "Mission",
    layout: "mission",
    bgColor: "bg-gray-900",
    titleStyle: "text-white text-7xl font-light",
    subtitleStyle: "text-white text-2xl",
    descriptionStyle: "text-white text-xl",
    circleStyle: "bg-amber-200 text-gray-900 font-bold",
    quoteStyle: "text-white text-lg italic"
  },
  // Design for Expertise slide (for slide 8)
{
    name: "Expertise",
    layout: "expertise",
    bgColor: "bg-gray-900",
    titleStyle: "text-white text-7xl font-light",
    bulletStyle: "text-white text-xl",
    overlayColor: "bg-gradient-to-r from-gray-500 to-transparent"
  },
  // Design 8: Premium Red
  {
    name: "Premium Red",
    layout: "top-image",
    bgColor: "bg-gradient-to-r from-red-100 to-red-50",
    titleStyle: "text-red-800 font-bold",
    subtitleStyle: "text-red-600",
    descriptionStyle: "text-gray-700",
    bulletStyle: "text-gray-700"
  },
  // Design 9: Coastal
  {
    name: "Coastal",
    layout: "split",
    bgColor: "bg-gradient-to-r from-cyan-50 to-blue-50",
    titleStyle: "text-cyan-800 font-bold",
    subtitleStyle: "text-cyan-600",
    descriptionStyle: "text-gray-700",
    bulletStyle: "text-gray-700"
  },
  // Design 10: Bold & Creative
  {
    name: "Bold & Creative",
    layout: "overlay",
    bgColor: "bg-purple-900",
    titleStyle: "text-yellow-400 font-bold",
    subtitleStyle: "text-purple-200",
    descriptionStyle: "text-gray-200",
    bulletStyle: "text-gray-200"
  },
  // Design for Contact/Connect slide
{
    name: "Contact",
    layout: "contact",
    bgColor: "bg-gradient-to-b from-gray-900 to-gray-800",
    titleStyle: "text-white text-5xl font-light italic",
    subtitleStyle: "text-white text-2xl",
    descriptionStyle: "text-white text-lg mt-8 leading-relaxed",
    bulletStyle: "text-white"
  }
];

// Main Component
const SellPage = ({ role }) => {

  // Default empty slides with different designs



  const MobileViewMessage = () => {
    return (
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 text-center shadow-md">
        <div className="mb-4 flex justify-center">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
          </svg>
        </div>
        <h3 className="text-xl font-semibold text-gray-800 mb-2">Desktop Experience Recommended</h3>
        <p className="text-gray-600 mb-4">
          Our interactive presentation slides are optimized for larger screens. 
          For the best experience, please view this content on a laptop or desktop device.
        </p>
        <div className="text-sm text-gray-500">
          <p>You can contact me directly for more information:</p>
          <a href="mailto:KarshB1@hotmail.com" className="text-blue-600 hover:text-blue-800 mt-2 inline-block">
          KarshB1@hotmail.com
          </a>
        </div>
      </div>
    );
  };

  // Add this style to enable text shadow on the full-image design
useEffect(() => {
    // Add text shadow class if it doesn't exist
    if (!document.getElementById('text-shadow-style')) {
      const style = document.createElement('style');
      style.id = 'text-shadow-style';
      style.innerHTML = `
        .text-shadow {
          text-shadow: 0 2px 4px rgba(0,0,0,0.5);
        }
      `;
      document.head.appendChild(style);
    }
    
    return () => {
      // Clean up
      const style = document.getElementById('text-shadow-style');
      if (style) style.parentNode.removeChild(style);
    };
  }, []);


  useEffect(() => {
    const fetchSlides = async () => {
      try {
        const response = await fetch(`${backendUrl}/api/get_sell_slides` , {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        const slides = await response.json();
  
        if (response.ok) {
            if (Array.isArray(slides)) {
                setSlides(slides);
              } else {
                setSlides([]); // fallback empty list
              }
              
        } else {
          console.error("Error fetching slides:", slides.message);
          setSlides(getEmptySlides()); // fallback on error
        }
      } catch (error) {
        console.error("Error fetching slides:", error);
        setSlides(getEmptySlides()); // fallback on exception
      }
    };
  
    fetchSlides();
  }, []);
  
  

  const handleDeleteSlide = (deleteIndex) => {
    const updatedSlides = slides.filter((_, index) => index !== deleteIndex);
    setSlides(updatedSlides);
    if (currentSlide >= updatedSlides.length) {
      setCurrentSlide(updatedSlides.length - 1);
    }
  };
  
  

  const getEmptySlides = () => {
    const slides = Array(13).fill().map((_, index) => {
        // Assign a specific design to each slide index
        let designIndex;
        switch(index) {
          case 0: designIndex = 0; break; // Arch Objectives
          case 1: designIndex = 1; break; // Modern Split
          case 2: designIndex = 2; break; // Luxury Dark
          // ...and so on for each slide
          default: designIndex = index % slideDesigns.length;
        }
        
        return {
          id: index + 1,
          title: "",
          subtitle: "",
          description: "",
          image: "",
          images: [],
          bulletPoints: [],
          design: slideDesigns[designIndex]
        };
      });
    
      // Add this at an appropriate point in your getEmptySlides function:
if (slides.length >= 9) {
    const contactDesignIndex = slideDesigns.findIndex(d => d.name === "Contact");
    slides[8].design = slideDesigns[contactDesignIndex];
    slides[8].title = "Stay In Touch";
    slides[8].description = "Presentations are communication tools that can be used as demonstrations, lectures, speeches, reports, and more. It is mostly presented before an audience. It serves a variety of purposes, making presentations powerful tools for convincing and teaching.";
  }

    // Assign the Market Knowledge design specifically to slide 4
    if (slides.length >= 4) {
      slides[3].design = slideDesigns[4]; // Market Knowledge design
      slides[3].title = "Market Knowledge & Strategy";
      slides[3].subtitle = "Edge Technology";
      slides[3].description = "Epic Professional photography, Expert Drone Photos, Online Listing Syndication, Targeted Social Media Campaigns, Email Outreach—Designed to Maximize Exposure, Attract Qualified Buyers Quickly.";
      slides[3].bulletPoints = [
        "Proven Record",
        "Track Record of Securing Favorable Deals on Behalf of Sellers- Higher Sales Prices, Fewer Contingencies, Flexible Closing Timelines, What Ever Works Best For YOU!!"
      ];

      if (slides.length >= 8) {
        const expertiseDesignIndex = slideDesigns.findIndex(d => d.name === "Expertise");
        slides[7].design = slideDesigns[expertiseDesignIndex];
        slides[7].title = "MY EXPERTISE";
        slides[7].bulletPoints = [
          "Experience & Track Record",
          "10+ Years of Full-Time Experience",
          "Over a decade navigating real estate market fluctuations - through both boom times and more challenging cycles.",
          "200+ Homes Sold",
          "Proven ability to deliver results consistently, helping hundreds of families and individuals achieve their real estate goals.",
          "Broad Transaction Variety",
          "Sales across single-family homes, condominiums, townhomes, and investment properties—gaining firsthand knowledge of virtually every property type."
        ];
      }


      // In the getEmptySlides function, add this after your slide 4 configuration:
if (slides.length >= 7) {
    const missionDesignIndex = slideDesigns.findIndex(d => d.name === "Mission");
    slides[6].design = slideDesigns[missionDesignIndex];
    slides[6].title = "MY MISSION";
    slides[6].description = "My goal has always been to help people and put their needs above my own. I don't worry about commissions—I worry about my clients and their success.";
    slides[6].bulletPoints = [
      "WHY",
      "I love real estate for what it has done for my family and for the countless people I've helped. It's amazing to see clients build wealth, transform their futures, and positively impact their families for generations.",
      "IMPACT",
      "It's not just about buying or selling a property—it's about helping people create a lasting legacy through real estate. Watching clients build security and wealth for future generations is what drives me every day.",
      "LEGACY",
      "Real estate is so much more than a transaction. It's about guiding families toward financial stability, peace of mind, and the freedom to pursue their dreams. That's why I pour my heart into every deal."
    ];
  }
    }
    
    return slides;
  };

  const [slides, setSlides] = useState([]);

  const [currentSlide, setCurrentSlide] = useState(0);
  const [editMode, setEditMode] = useState(false);
  const [editData, setEditData] = useState(null);
  const [newBulletPoint, setNewBulletPoint] = useState("");
  const [isUploading, setIsUploading] = useState(false);

  // Handle Previous Slide
  const prevSlide = () => {
    setCurrentSlide(prev => (prev === 0 ? slides.length - 1 : prev - 1));
  };

  // Handle Next Slide
  const nextSlide = () => {
    setCurrentSlide(prev => (prev === slides.length - 1 ? 0 : prev + 1));
  };

  // Enter Edit Mode
const handleEdit = () => {
  // Make sure to initialize images array if it doesn't exist
  const currentSlideData = {...slides[currentSlide]};
  if (!currentSlideData.images) {
    currentSlideData.images = [];
  }
  
  // If it's a centered layout with a single image, migrate it
  if (currentSlideData.design.layout === "centered" && currentSlideData.image) {
    currentSlideData.images = [currentSlideData.image, ...currentSlideData.images];
    currentSlideData.image = "";
  }
  
  setEditData(currentSlideData);
  setEditMode(true);
};

  // Add Bullet Point
  const handleAddBulletPoint = () => {
    if (newBulletPoint.trim()) {
      setEditData({
        ...editData,
        bulletPoints: [...editData.bulletPoints, newBulletPoint.trim()]
      });
      setNewBulletPoint("");
    }
  };

  // Remove Bullet Point
  const handleRemoveBulletPoint = (index) => {
    setEditData({
      ...editData,
      bulletPoints: editData.bulletPoints.filter((_, i) => i !== index)
    });
  };



  // Add this function to your component
const handleReorderSlides = (startIndex, endIndex) => {
    const result = [...slides];
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    setSlides(result);
    
    // If the current slide was moved, update currentSlide to follow it
    if (currentSlide === startIndex) {
      setCurrentSlide(endIndex);
    } 
    // If current slide was shifted due to reordering, adjust its index
    else if (
      (startIndex < currentSlide && endIndex >= currentSlide) ||
      (startIndex > currentSlide && endIndex <= currentSlide)
    ) {
      setCurrentSlide(currentSlide + (startIndex < endIndex ? -1 : 1));
    }
  };
  // Handle Image Upload
  const handleImageUpload = async (e) => {
    const files = e.target.files;
    if (!files || files.length === 0) return;
  
    setIsUploading(true);
    const uploadedUrls = [];
  
    // Loop through files and upload each one to Cloudinary
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const formData = new FormData();
      formData.append("file", file);
      formData.append("upload_preset", "Brian_Karsh"); // Cloudinary preset
  
      try {
        const response = await fetch("https://api.cloudinary.com/v1_1/dyglrkcfq/image/upload", {
          method: "POST",
          body: formData,
        });
        const result = await response.json();
        if (response.ok) {
          uploadedUrls.push(result.secure_url);
        } else {
          console.error("Error uploading to Cloudinary:", result.message);
        }
      } catch (error) {
        console.error("Error uploading image:", error);
      }
    }
  
    // For designs that expect multiple images (like "arch-objectives"),
// In your handleImageUpload function
if (editData.design.layout === "arch-objectives" || editData.design.layout === "centered") {
  // If there's a single image and this is the first time uploading to images array, move it
  let newImages = [...(editData.images || [])];
  
  // If we're now handling an image for a layout that used to use single images
  if (editData.design.layout === "centered" && editData.image && newImages.length === 0) {
    newImages.push(editData.image); // Add the existing single image first
  }
  
  // Now add the newly uploaded images
  newImages = [...newImages, ...uploadedUrls];
  
  // Make sure we don't exceed 3 images for centered layout
  if (editData.design.layout === "centered" && newImages.length > 3) {
    newImages = newImages.slice(0, 3);
  }
  
  setEditData({
    ...editData,
    images: newImages,
    image: "" // Clear the single image
  });
} else {
  setEditData({
    ...editData,
    image: uploadedUrls[0]
  });
}
  
    setIsUploading(false);
  };
  
  

  // Add this to your component
const clearSingleImage = () => {
  if (editData.image) {
    // If there's a single image, move it to the images array
    setEditData({
      ...editData,
      images: editData.image ? [editData.image] : [],
      image: ""
    });
  }
};

const handleCloseEdit = () => {
  setEditMode(false);
  setEditData(null);
};

  // Add this function with your other handlers
const handleRemoveImage = (index) => {
  setEditData({
    ...editData,
    images: editData.images.filter((_, i) => i !== index)
  });
};


  // Save Slide Changes
// Replace your existing handleSaveChanges function
const handleSaveChanges = async () => {
  // Check if the edited slide needs pagination
  const paginatedSlides = splitLongSlideContent(editData);
  
  // Create updated slides array
  let updatedSlides = [...slides];
  
  if (paginatedSlides.length > 1) {
    // Replace the current slide with the first paginated slide
    updatedSlides[currentSlide] = paginatedSlides[0];
    
    // Insert continuation slides after the current slide
    for (let i = 1; i < paginatedSlides.length; i++) {
      updatedSlides.splice(currentSlide + i, 0, paginatedSlides[i]);
    }
    
    // Show notification to user
    alert(`Content was split into ${paginatedSlides.length} slides due to length.`);
  } else {
    // No pagination needed, update normally
    updatedSlides[currentSlide] = editData;
  }
  
  // Update the slides state
  setSlides(updatedSlides);
  setEditMode(false);
  setEditData(null);

  console.log("Saving slides with pagination:", updatedSlides);

  try {
    const response = await fetch(`${backendUrl}/api/save_sell_slides`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      body: JSON.stringify({ slides: updatedSlides }),
    });
    
    const result = await response.json();
    if (response.ok) {
      console.log("Slides saved successfully:", result.message);
      // Optionally, show a success message
    } else {
      console.error("Error saving slides:", result.msg);
    }
  } catch (error) {
    console.error("Error saving slides:", error);
  }
};
  

  // Remove an image from the arch-objectives design
  const handleRemoveArchImage = (index) => {
    setEditData({
      ...editData,
      images: editData.images.filter((_, i) => i !== index)
    });
  };

  

  // Add a new empty slide 
const handleAddSlide = (designType = "full-image") => {
    const designIndex = slideDesigns.findIndex(d => d.name === designType);
    const newSlide = {
      id: slides.length + 1,
      title: "",
      subtitle: "",
      description: "",
      image: "",
      images: [],
      bulletPoints: [],
      design: slideDesigns[designIndex >= 0 ? designIndex : 0]
    };
    
    setSlides([...slides, newSlide]);
    // Optional: navigate to the new slide
    setCurrentSlide(slides.length);
  };


  // Add this before your state declarations
const getMaxBulletPointsForDesign = (designLayout) => {
  switch (designLayout) {
    case "expertise":
      return 7; // Expertise design can fit about 7 points comfortably
    case "market-knowledge":
      return 4; // Market knowledge has limited space
    case "mission":
      return 6; // Mission needs pairs of points for each circle
    case "arch-objectives":
      return 4; // Arch objectives has limited space for bullet points
    default:
      return 6; // Default for most layouts
  }
};


// Add this after the helper function
const splitLongSlideContent = (slide) => {
  const maxBulletPoints = getMaxBulletPointsForDesign(slide.design.layout);
  
  // If the slide doesn't exceed the bullet point limit, return it as is
  if (!slide.bulletPoints || slide.bulletPoints.length <= maxBulletPoints) {
    return [slide];
  }
  
  // Create an array to hold all paginated slides
  const paginatedSlides = [];
  
  // Clone the original slide for the first page
  const firstSlide = {...slide};
  firstSlide.bulletPoints = slide.bulletPoints.slice(0, maxBulletPoints);
  paginatedSlides.push(firstSlide);
  
  // Create continuation slides with remaining bullet points
  let remainingPoints = slide.bulletPoints.slice(maxBulletPoints);
  let pageCount = 2;
  
  while (remainingPoints.length > 0) {
    // Create a continuation slide with the same design
    const continuationSlide = {
      ...JSON.parse(JSON.stringify(slide)), // Deep clone to avoid reference issues
      id: slide.id + `-page${pageCount}`,
      title: `${slide.title} (cont. ${pageCount})`,
      bulletPoints: remainingPoints.slice(0, maxBulletPoints)
    };
    
    paginatedSlides.push(continuationSlide);
    remainingPoints = remainingPoints.slice(maxBulletPoints);
    pageCount++;
  }
  
  return paginatedSlides;
};


  // Render the current slide based on its design
  const renderSlide = (slide) => {
    const { design } = slide;
    
    switch (design.layout) {
      case "arch-objectives":
        return (
          <div className={`flex flex-col h-full ${design.bgColor} relative`}>
            {/* Logo at top left */}
            <div className="absolute top-4 left-4 z-10">
              <div className="text-white text-xs">
                <div className="flex items-center">
                  <div className="mr-2">
                    <svg width="40" height="30" viewBox="0 0 100 70" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M50 0L0 40H20V70H80V40H100L50 0Z" fill="#ffffff" fillOpacity="0.6"/>
                    </svg>
                  </div>
                  <div>
                    <div className="font-bold tracking-wider">BRIAN</div>
                    <div className="text-[8px] tracking-wider text-gray-400">REAL ESTATE</div>
                    <div className="font-bold tracking-wider">KARSH</div>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Main content - 3 arches */}
            <div className="flex-1 flex flex-col md:flex-row items-stretch p-4 gap-4 mt-12">
              {/* First arch */}
              <div className="flex-1 flex flex-col rounded-t-full overflow-hidden border border-gray-700">
                <div className="text-center p-4 text-2xl font-light" style={{color:'white'}}>{slide.title || "Objectives"}</div>
                <div className="flex-1 overflow-hidden">
                  {slide.image || (slide.images && slide.images[0]) ? (
                    <img 
                      src={slide.image || slide.images[0]} 
                      alt="Objective 1" 
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <div className="w-full h-full bg-gray-800 flex items-center justify-center">
                      <Image size={48} className="text-gray-600" />
                    </div>
                  )}
                </div>
                <div className="p-6 flex flex-col items-center text-center">
                  <h3 className={design.subtitleStyle}>{slide.subtitle || "EMPOWER CLIENTS"}</h3>
                  <p className={design.descriptionStyle + " mt-4"}>
                    {slide.description || "Provide clear, honest information so they can make the best decisions for their future."}
                  </p>
                </div>
              </div>
              
              {/* Second arch */}
              <div className="flex-1 flex flex-col rounded-t-full overflow-hidden border border-gray-700">
                <div className="text-center p-4 text-2xl font-light" style={{color:'white'}}>{slide.title || "Objectives"}</div>

                <div className="flex-1 overflow-hidden">
                  {slide.images && slide.images[1] ? (
                    <img 
                      src={slide.images[1]} 
                      alt="Objective 2" 
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <div className="w-full h-full bg-gray-800 flex items-center justify-center">
                      <Image size={48} className="text-gray-600" />
                    </div>
                  )}
                </div>
                <div className="p-6 flex flex-col items-center text-center">
                  <h3 className={design.subtitleStyle}>
                    {slide.bulletPoints && slide.bulletPoints[0] ? slide.bulletPoints[0] : "MAXIMIZE VALUE"}
                  </h3>
                  <p className={design.descriptionStyle + " mt-4"}>
                    {slide.bulletPoints && slide.bulletPoints[1] ? slide.bulletPoints[1] : "Utilize expert negotiation and strategic marketing to help clients build long-term wealth."}
                  </p>
                </div>
              </div>
              
              {/* Third arch */}
              <div className="flex-1 flex flex-col rounded-t-full overflow-hidden border border-gray-700">
              <div className="text-center p-4 text-2xl font-light" style={{color:'white'}}>{slide.title || "Objectives"}</div>
              <div className="flex-1 overflow-hidden">
                  {slide.images && slide.images[2] ? (
                    <img 
                      src={slide.images[2]} 
                      alt="Objective 3" 
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <div className="w-full h-full bg-gray-800 flex items-center justify-center">
                      <Image size={48} className="text-gray-600" />
                    </div>
                  )}
                </div>
                <div className="p-6 flex flex-col items-center text-center">
                  <h3 className={design.subtitleStyle}>
                    {slide.bulletPoints && slide.bulletPoints[2] ? slide.bulletPoints[2] : "ENSURE SATISFACTION"}
                  </h3>
                  <p className={design.descriptionStyle + " mt-4"}>
                    {slide.bulletPoints && slide.bulletPoints[3] ? slide.bulletPoints[3] : "Deliver an exceptional experience from the first conversation through closing and beyond."}
                  </p>
                </div>
              </div>
            </div>
          </div>
        );
        
      case "split":
        return (
          <div className={`flex flex-col md:flex-row h-full ${design.bgColor}`}>
            <div className="md:w-1/2 p-8 flex flex-col justify-center">
              <h2 className={`text-3xl md:text-4xl mb-4 ${design.titleStyle}`}>{slide.title || "Add Your Title"}</h2>
              <h3 className={`text-xl mb-6 ${design.subtitleStyle}`}>{slide.subtitle || "Add Your Subtitle"}</h3>
              <p className={`mb-6 ${design.descriptionStyle}`}>{slide.description || "Add your description here..."}</p>
              {slide.bulletPoints && slide.bulletPoints.length > 0 && (
                <ul className="space-y-2">
                  {slide.bulletPoints.map((point, index) => (
                    <li key={index} className={`flex items-start ${design.bulletStyle}`}>
                      <span className="mr-2">•</span>
                      <span>{point}</span>
                    </li>
                  ))}
                </ul>
              )}
            </div>
            <div className="md:w-1/2 flex items-center justify-center p-4">
              {slide.image ? (
                <img src={slide.image} alt={slide.title} className="max-h-full object-contain rounded-lg shadow-lg" />
              ) : (
                <div className="w-full h-64 bg-gray-200 rounded-lg flex items-center justify-center">
                  <Image size={48} className="text-gray-400" />
                </div>
              )}
            </div>
          </div>
        );


        case "contact":
          return (
            <div className={`flex flex-col md:flex-row h-full ${design.bgColor}`}>
              {/* Left column - Social Media Icons */}
              <div className="md:w-1/2 bg-gray-900 p-12 flex flex-col items-center justify-center">
                {/* Title with improved typography */}
                <h3 className="text-4xl font-light tracking-wide text-amber-400 mb-12 border-b-2 border-amber-400 pb-2 italic">
                  CONNECT WITH ME
                </h3>
                
                {/* Social Icons Grid - cleaner, more professional look */}
                <div className="grid grid-cols-2 gap-10 w-full max-w-md">
                  {/* LinkedIn */}
                  <div className="flex flex-col items-center group">
                    <div className="w-20 h-20 rounded-full bg-blue-600 flex items-center justify-center mb-3 transition-all duration-300 group-hover:shadow-lg group-hover:shadow-blue-500/30">
                      <svg viewBox="0 0 24 24" width="36" height="36" fill="white">
                        <path d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.79M6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77z" />
                      </svg>
                    </div>
                    <span className="text-white text-lg font-light tracking-wide">LinkedIn</span>
                  </div>
                  
                  {/* Instagram */}
                  <div className="flex flex-col items-center group">
                    <div className="w-20 h-20 rounded-full bg-gradient-to-br from-purple-600 via-pink-500 to-orange-400 flex items-center justify-center mb-3 transition-all duration-300 group-hover:shadow-lg group-hover:shadow-pink-500/30">
                      <svg viewBox="0 0 24 24" width="36" height="36" fill="white">
                        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
                      </svg>
                    </div>
                    <span className="text-white text-lg font-light tracking-wide">Instagram</span>
                  </div>
                  
                  {/* Twitter/X */}
                  <div className="flex flex-col items-center group">
                    <div className="w-20 h-20 rounded-full bg-black border border-gray-700 flex items-center justify-center mb-3 transition-all duration-300 group-hover:shadow-lg group-hover:shadow-white/20">
                      <svg viewBox="0 0 24 24" width="32" height="32" fill="white">
                        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                      </svg>
                    </div>
                    <span className="text-white text-lg font-light tracking-wide">Twitter</span>
                  </div>
                  
                  {/* YouTube */}
                  <div className="flex flex-col items-center group">
                    <div className="w-20 h-20 rounded-full bg-red-600 flex items-center justify-center mb-3 transition-all duration-300 group-hover:shadow-lg group-hover:shadow-red-500/30">
                      <svg viewBox="0 0 24 24" width="36" height="36" fill="white">
                        <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z"/>
                      </svg>
                    </div>
                    <span className="text-white text-lg font-light tracking-wide">YouTube</span>
                  </div>
                </div>
                
                {/* Contact Info - styled to match right side */}
                <div className="mt-12 flex flex-col items-center pt-6 border-t border-gray-700 w-full max-w-md">
                  <div className="flex items-center mb-4">
                    <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-amber-400 mr-3">
                      <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z" />
                    </svg>
                    <p className="text-white text-lg font-light">+1 702-695-7917</p>
                  </div>
                  <div className="flex items-center">
                    <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-amber-400 mr-3">
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                      <path d="M22 6l-10 7L2 6" />
                    </svg>
                    <p className="text-white text-lg font-light">KarshB1@hotmail.com</p>
                  </div>
                </div>
              </div>
              
              {/* Right column - Text content */}
              <div className="md:w-1/2 bg-gray-900 p-12 flex flex-col justify-center">
                <h2 className="text-5xl font-light italic text-white mb-12">{slide.title || "Stay In Touch"}</h2>
                <div className="mt-6">
                  <p className="text-white text-lg leading-relaxed">
                    {slide.description || "Presentations are communication tools that can be used as demonstrations, lectures, speeches, reports, and more. It is mostly presented before an audience. It serves a variety of purposes, making presentations powerful tools for convincing and teaching."}
                  </p>
                </div>
                
           
                
             
              </div>
            </div>
          );


        case "expertise":
  return (
    <div className="relative h-full w-full">
      {/* Background Image */}
      {slide.image ? (
        <div className="absolute inset-0 z-0">
          <img src={slide.image} alt="" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-black opacity-50"></div>
        </div>
      ) : (
        <div className="absolute inset-0 bg-gradient-to-r from-gray-500 to-gray-900"></div>
      )}
      
      {/* Content Overlay */}
      <div className="relative flex h-full">
        {/* Left column with content */}
        <div className="w-2/3 p-10 flex flex-col">
          {/* Title */}
          <h1 className={design.titleStyle + " mb-16"}>{slide.title || "MY EXPERTISE"}</h1>
          
          {/* Bullet Points */}
          <ul className="space-y-4">
            {slide.bulletPoints && slide.bulletPoints.length > 0 ? (
              slide.bulletPoints.map((point, idx) => (
                <li key={idx} className="flex items-start">
                  <span className="mr-3 mt-1.5 text-white">•</span>
                  <span className={design.bulletStyle}>{point}</span>
                </li>
              ))
            ) : (
              <>
                <li className="flex items-start">
                  <span className="mr-3 mt-1.5 text-white">•</span>
                  <span className={design.bulletStyle}>Experience & Track Record</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-3 mt-1.5 text-white">•</span>
                  <span className={design.bulletStyle}>10+ Years of Full-Time Experience</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-3 mt-1.5 text-white">•</span>
                  <span className={design.bulletStyle}>200+ Homes Sold</span>
                </li>
              </>
            )}
          </ul>
        </div>
        
   
      </div>
    </div>
  );
        
      case "split-reverse":
        return (
          <div className={`flex flex-col md:flex-row h-full ${design.bgColor}`}>
            <div className="md:w-1/2 flex items-center justify-center p-4 order-1 md:order-0">
              {slide.image ? (
                <img src={slide.image} alt={slide.title} className="max-h-full object-contain rounded-lg shadow-lg" />
              ) : (
                <div className="w-full h-64 bg-gray-200 rounded-lg flex items-center justify-center">
                  <Image size={48} className="text-gray-400" />
                </div>
              )}
            </div>
            <div className="md:w-1/2 p-8 flex flex-col justify-center order-0 md:order-1">
              <h2 className={`text-3xl md:text-4xl mb-4 ${design.titleStyle}`}>{slide.title || "Add Your Title"}</h2>
              <h3 className={`text-xl mb-6 ${design.subtitleStyle}`}>{slide.subtitle || "Add Your Subtitle"}</h3>
              <p className={`mb-6 ${design.descriptionStyle}`}>{slide.description || "Add your description here..."}</p>
              {slide.bulletPoints && slide.bulletPoints.length > 0 && (
                <ul className="space-y-2">
                  {slide.bulletPoints.map((point, index) => (
                    <li key={index} className={`flex items-start ${design.bulletStyle}`}>
                      <span className="mr-2">•</span>
                      <span>{point}</span>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        );
        
        case "centered":
          return (
            <div className={`flex flex-col items-center justify-center h-full p-8 text-center ${design.bgColor}`}>
              <h2 className={`text-3xl md:text-5xl mb-4 ${design.titleStyle}`}>{slide.title || "Add Your Title"}</h2>
              <h3 className={`text-xl md:text-2xl mb-6 ${design.subtitleStyle}`}>{slide.subtitle || "Add Your Subtitle"}</h3>
              
              {/* Only use the images array, remove the single image section */}
              {slide.images && slide.images.length > 0 ? (
                <div className="my-6 grid grid-cols-3 gap-4 w-full max-w-4xl">
                  {slide.images.map((img, idx) => (
                    <div key={idx} className="flex justify-center">
                      <img src={img} alt={`${slide.title} ${idx + 1}`} className="max-h-48 object-contain rounded-lg shadow-lg" />
                    </div>
                  ))}
                  {Array(3 - (slide.images ? slide.images.length : 0)).fill(0).map((_, idx) => (
                    <div key={`empty-${idx}`} className="h-48 bg-gray-200 rounded-lg flex items-center justify-center">
                      <Image size={32} className="text-gray-400" />
                    </div>
                  ))}
                </div>
              ) : (
                <div className="my-6 grid grid-cols-3 gap-4 w-full max-w-4xl">
                  {Array(3).fill(0).map((_, idx) => (
                    <div key={idx} className="h-48 bg-gray-200 rounded-lg flex items-center justify-center">
                      <Image size={32} className="text-gray-400" />
                    </div>
                  ))}
                </div>
              )}
              
              <p className={`max-w-2xl mb-6 ${design.descriptionStyle}`}>{slide.description || "Add your description here..."}</p>
              {slide.bulletPoints && slide.bulletPoints.length > 0 && (
                <ul className="space-y-2 text-left max-w-2xl mx-auto">
                  {slide.bulletPoints.map((point, index) => (
                    <li key={index} className={`flex items-start ${design.bulletStyle}`}>
                      <span className="mr-2">•</span>
                      <span>{point}</span>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          );

        case "mission":
  return (
    <div className={`flex h-full ${design.bgColor} relative`}>
      {/* Left section - Image, Title and Description */}
      <div className="w-1/2 flex flex-col p-8">
        {/* Title */}
        <div className="mb-8">
          <h1 className={design.titleStyle}>{slide.title || "MY MISSION"}</h1>
        </div>
        
        {/* Main quote */}
        <div className="mt-4 mb-8">
          <p className="text-xl text-white">
            {slide.description || "My goal has always been to help people and put their needs above my own. I don't worry about commissions—I worry about my clients and their success."}
          </p>
        </div>
        
        {/* Image */}
        <div className="flex-1 mt-auto">
          {slide.image ? (
            <img src={slide.image} alt={slide.title} className="w-2/3 h-full object-cover" />
          ) : (
            <div className="w-full h-64 opacity-50">
              <Image size={64} className="text-gray-400" />
            </div>
          )}
        </div>
        
    
      </div>
      
      {/* Right section - Three circles with descriptions */}
      <div className="w-1/2 p-8 flex flex-col justify-center space-y-16">
        {/* WHY Circle */}
        <div className="flex items-center space-x-4">
          <div className="w-28 h-28 rounded-full flex items-center justify-center text-2xl flex-shrink-0" 
               style={{backgroundColor: '#E5C9B1'}}>
            <span className="font-bold text-gray-900">WHY</span>
          </div>
          <p className="text-white">
            {slide.bulletPoints && slide.bulletPoints[1] ? slide.bulletPoints[1] : 
            "I love real estate for what it has done for my family and for the countless people I've helped. It's amazing to see clients build wealth, transform their futures, and positively impact their families for generations."}
          </p>
        </div>
        
        {/* IMPACT Circle */}
        <div className="flex items-center space-x-4">
          <div className="w-28 h-28 rounded-full flex items-center justify-center text-2xl flex-shrink-0"
               style={{backgroundColor: '#E5C9B1'}}>
            <span className="font-bold text-gray-900">IMPACT</span>
          </div>
          <p className="text-white">
            {slide.bulletPoints && slide.bulletPoints[3] ? slide.bulletPoints[3] : 
            "It's not just about buying or selling a property—it's about helping people create a lasting legacy through real estate. Watching clients build security and wealth for future generations is what drives me every day."}
          </p>
        </div>
        
        {/* LEGACY Circle */}
        <div className="flex items-center space-x-4">
          <div className="w-28 h-28 rounded-full flex items-center justify-center text-2xl flex-shrink-0"
               style={{backgroundColor: '#E5C9B1'}}>
            <span className="font-bold text-gray-900">LEGACY</span>
          </div>
          <p className="text-white">
            {slide.bulletPoints && slide.bulletPoints[5] ? slide.bulletPoints[5] : 
            "Real estate is so much more than a transaction. It's about guiding families toward financial stability, peace of mind, and the freedom to pursue their dreams. That's why I pour my heart into every deal."}
          </p>
        </div>
      </div>
    </div>
  );
        
      case "overlay":
        return (
          <div className={`relative h-full flex items-center justify-center ${design.bgColor}`}>
            {slide.image ? (
              <div className="absolute inset-0">
                <div className="absolute inset-0 bg-black opacity-40"></div>
                <img src={slide.image} alt={slide.title} className="w-full h-full object-cover" />
              </div>
            ) : (
              <div className="absolute inset-0 bg-black opacity-10"></div>
            )}
            <div className="relative z-10 max-w-3xl p-8 mx-4 bg-black bg-opacity-50 rounded-lg">
              <h2 className={`text-3xl md:text-4xl mb-4 ${design.titleStyle}`}>{slide.title || "Add Your Title"}</h2>
              <h3 className={`text-xl mb-6 ${design.subtitleStyle}`}>{slide.subtitle || "Add Your Subtitle"}</h3>
              <p className={`mb-6 ${design.descriptionStyle}`}>{slide.description || "Add your description here..."}</p>
              {slide.bulletPoints && slide.bulletPoints.length > 0 && (
                <ul className="space-y-2">
                  {slide.bulletPoints.map((point, index) => (
                    <li key={index} className={`flex items-start ${design.bulletStyle}`}>
                      <span className="mr-2">•</span>
                      <span>{point}</span>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        );
        case "market-knowledge":
  return (
    <div className={`flex flex-col h-full ${design.bgColor} relative`}>
      {/* Main content container */}
      <div className="flex h-full">
        {/* Left column - Image and Title */}
        <div className="w-1/2 flex flex-col">
          {/* Image section */}
          <div className="h-2/3 overflow-hidden">
            {slide.image ? (
              <img src={slide.image} alt={slide.title} className="w-full h-full object-cover" />
            ) : (
              <div className="w-full h-full bg-gray-200 flex items-center justify-center">
                <Image size={64} className="text-gray-400" />
              </div>
            )}
          </div>
          
          {/* Title section */}
          <div className="h-1/3 flex items-center p-8">
            <h1 className={design.titleStyle}>{slide.title || "Market Knowledge & Strategy"}</h1>
          </div>
          
     
        </div>
        
        {/* Right column - Feature boxes */}
        <div className="w-1/2 bg-gray-900 p-8 flex flex-col justify-center space-y-8">
          {/* Feature box 1 */}
          <div className="space-y-4">
            <div className="flex items-center space-x-4">
              <div className="w-10 h-10 flex items-center justify-center">
                <svg viewBox="0 0 24 24" width="24" height="24" className="text-gray-100">
                  <circle cx="12" cy="12" r="11" stroke="currentColor" fill="none" strokeWidth="2"/>
                  <path d="M7 12 L11 16 L17 8" stroke="currentColor" strokeWidth="2" fill="none"/>
                </svg>
              </div>
              <div className={`${design.featureBoxBg} px-8 py-2 rounded-md`}>
                <h3 className="text-3xl font-bold">{slide.subtitle || "Edge Technology"}</h3>
              </div>
            </div>
            <p className="text-gray-300 pl-14">
              {slide.description || "Epic Professional photography, Expert Drone Photos, Online Listing Syndication, Targeted Social Media Campaigns, Email Outreach—Designed to Maximize Exposure, Attract Qualified Buyers Quickly."}
            </p>
          </div>
          
          {/* Feature box 2 */}
          <div className="space-y-4">
            <div className="flex items-center space-x-4">
              <div className="w-10 h-10 flex items-center justify-center">
                <svg viewBox="0 0 24 24" width="24" height="24" className="text-gray-100">
                  <circle cx="12" cy="12" r="11" stroke="currentColor" fill="none" strokeWidth="2"/>
                  <circle cx="12" cy="12" r="5" stroke="currentColor" fill="none" strokeWidth="2"/>
                  <circle cx="12" cy="12" r="2" fill="currentColor"/>
                </svg>
              </div>
              <div className={`${design.featureBoxBg} px-8 py-2 rounded-md`}>
                <h3 className="text-3xl font-bold">
                  {slide.bulletPoints && slide.bulletPoints[0] 
                    ? slide.bulletPoints[0] 
                    : "Proven Record"}
                </h3>
              </div>
            </div>
            <p className="text-gray-300 pl-14">
              {slide.bulletPoints && slide.bulletPoints[1] 
                ? slide.bulletPoints[1] 
                : "Track Record of Securing Favorable Deals on Behalf of Sellers- Higher Sales Prices, Fewer Contingencies, Flexible Closing Timelines, What Ever Works Best For YOU!!"}
            </p>
          </div>
        </div>
      </div>
    </div>
  );


  case "full-image":
  return (
    <div className="relative h-full w-full bg-black">
      {/* Full-size Image */}
      {slide.image ? (
        <div className="absolute inset-0">
          <img 
            src={slide.image} 
            alt={slide.title} 
            className="w-full h-full object-contain" 
          />
        </div>
      ) : (
        <div className="w-full h-full flex flex-col items-center justify-center">
          <Image size={96} className="text-gray-700 mb-4" />
          <p className="text-gray-500 text-lg">Upload an image to display here</p>
        </div>
      )}
      
      {/* Optional overlay text */}
      {(slide.title || slide.subtitle || slide.description) && (
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent">
          {slide.subtitle && (
            <h3 className={design.subtitleStyle}>{slide.subtitle}</h3>
          )}
          {slide.title && (
            <h2 className={design.titleStyle}>{slide.title}</h2>
          )}
          {slide.description && (
            <p className={design.descriptionStyle}>{slide.description}</p>
          )}
        </div>
      )}
    </div>
  );
        
      case "top-image":
        return (
          <div className={`flex flex-col h-full ${design.bgColor}`}>
            <div className="h-1/2 overflow-hidden">
              {slide.image ? (
                <img src={slide.image} alt={slide.title} className="w-full h-full object-cover" />
              ) : (
                <div className="w-full h-full bg-gray-300 flex items-center justify-center">
                  <Image size={64} className="text-gray-500" />
                </div>
              )}
            </div>
            <div className="h-1/2 p-8 flex flex-col justify-center">
              <h2 className={`text-3xl md:text-4xl mb-4 ${design.titleStyle}`}>{slide.title || "Add Your Title"}</h2>
              <h3 className={`text-xl mb-4 ${design.subtitleStyle}`}>{slide.subtitle || "Add Your Subtitle"}</h3>
              <p className={`mb-4 ${design.descriptionStyle}`}>{slide.description || "Add your description here..."}</p>
              {slide.bulletPoints && slide.bulletPoints.length > 0 && (
                <ul className="space-y-2">
                  {slide.bulletPoints.map((point, index) => (
                    <li key={index} className={`flex items-start ${design.bulletStyle}`}>
                      <span className="mr-2">•</span>
                      <span>{point}</span>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        );
        
      default:
        return (
          <div className="flex items-center justify-center h-full bg-gray-100">
            <p>Slide layout not found</p>
          </div>
        );
    }
  };

  return (
    <div className="w-full max-w-6xl mx-auto p-4 mt-44">


<div className="block md:hidden">
      <MobileViewMessage />
    </div>
    <div className="hidden md:block">

      <div className="bg-white rounded-lg shadow-lg overflow-hidden">
        {/* Slide Viewer */}
        <div className="relative h-96 md:h-screen md:max-h-[70vh] overflow-hidden">
        {slides[currentSlide] ? renderSlide(slides[currentSlide]) : null}

          
          {/* Navigation Controls */}
          {/* <div className="absolute bottom-4 left-0 right-0 flex justify-center space-x-4">
            <Button color="gray" onClick={prevSlide} className="flex items-center">
              <ChevronLeft size={16} className="mr-1" /> Prev
            </Button>
            <span className="px-4 py-2 bg-gray-100 rounded-md text-gray-800">
              {currentSlide + 1} / {slides.length}
            </span>
            <Button color="gray" onClick={nextSlide} className="flex items-center">
              Next <ChevronRight size={16} className="ml-1" />
            </Button>
          </div> */}
          
          {/* Edit Button */}
          {role === "owner" && (
  <button 
    onClick={handleEdit} 
    className="absolute top-4 right-4 bg-white rounded-full p-2 shadow-md hover:bg-gray-100"
  >
    <Edit2 size={18} className="text-gray-700" />
  </button>
)}

        </div>
        
       {/* Slide Numbers */}
<div className="bg-gray-100 p-4 overflow-x-auto">
  <div className="flex justify-center space-x-2">
    {slides.map((slide, index) => (
      <button
        key={index}
        onClick={() => setCurrentSlide(index)}
        className={`w-10 h-10 rounded-full flex items-center justify-center 
          ${currentSlide === index 
            ? 'bg-blue-500 text-white font-bold' 
            : 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-50'
          } transition-colors`}
      >
        {index + 1}
      </button>
    ))}
  </div>
</div>
      </div>
      
      {/* Edit Modal */}
      {editMode && editData && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4 backdrop-blur-sm">
          <div className="bg-white rounded-lg shadow-xl max-w-3xl w-full max-h-[90vh] overflow-y-auto">
            <div className="flex justify-between items-center p-4 border-b">
              <h2 className="text-xl font-bold">Edit Slide {currentSlide + 1}</h2>
              <button onClick={handleCloseEdit} className="text-gray-500 hover:text-gray-700">
                <X size={20} />
              </button>
            </div>
            
            <div className="p-6 space-y-6">
              {/* Title */}
              <div>
                <label className="block font-medium text-gray-700 mb-2">Title</label>
                <input
                  type="text"
                  className="w-full border border-gray-300 rounded-md px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  value={editData.title}
                  onChange={(e) => setEditData({...editData, title: e.target.value})}
                  placeholder="Enter slide title"
                />
              </div>
              
              {/* Subtitle */}
              <div>
                <label className="block font-medium text-gray-700 mb-2">Subtitle</label>
                <input
                  type="text"
                  className="w-full border border-gray-300 rounded-md px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  value={editData.subtitle}
                  onChange={(e) => setEditData({...editData, subtitle: e.target.value})}
                  placeholder="Enter slide subtitle"
                />
              </div>
              
              {/* Description */}
              <div>
                <label className="block font-medium text-gray-700 mb-2">Description</label>
                <textarea
                  rows={4}
                  className="w-full border border-gray-300 rounded-md px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-none"
                  value={editData.description}
                  onChange={(e) => setEditData({...editData, description: e.target.value})}
                  placeholder="Enter slide description"
                />
              </div>
              
              {/* Image Upload */}
              <div>
{editData.design.layout === "arch-objectives" || editData.design.layout === "centered" ? (
  <div className="space-y-4">
    {/* Display multiple images */}
    {editData.images && editData.images.length > 0 && (
      <div className="grid grid-cols-3 gap-2">
        {editData.images.map((img, idx) => (
          <div key={idx} className="relative">
            <img src={img} alt={editData.design.layout === "arch-objectives" ? 
              `Objective ${idx + 1}` : `Image ${idx + 1}`} 
              className="w-full h-24 object-cover rounded" />
            <button 
              onClick={() => editData.design.layout === "arch-objectives" ? 
                handleRemoveArchImage(idx) : handleRemoveImage(idx)}
              className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-1 hover:bg-red-600"
            >
              <X size={16} />
            </button>
            <div className="text-xs text-center mt-1">
              {editData.design.layout === "arch-objectives" ? `Arch ${idx + 1}` : `Image ${idx + 1}`}
            </div>
          </div>
        ))}
      </div>
    )}
    
    {/* Upload button */}
    <div className="border-2 border-dashed border-gray-300 rounded-md p-4 w-full text-center hover:bg-gray-50 transition duration-150 cursor-pointer">
      <input 
        type="file" 
        accept="image/*" 
        onChange={handleImageUpload}
        className="hidden" 
        id="multi-image-upload"
        disabled={isUploading || (editData.images && editData.images.length >= 3)}
      />
      <label htmlFor="multi-image-upload" className={`cursor-pointer ${isUploading || (editData.images && editData.images.length >= 3) ? 'opacity-50' : ''}`}>
        {isUploading ? (
          <div className="flex flex-col items-center">
            <svg className="animate-spin h-8 w-8 text-blue-500 mb-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            <span className="text-sm font-medium text-gray-700">Uploading...</span>
          </div>
        ) : (
          <>
            <Image className="mx-auto h-8 w-8 text-gray-400" />
            <span className="mt-1 block text-sm font-medium text-gray-700">
              {editData.design.layout === "arch-objectives" ? "Add another arch image" : "Add another image"}
            </span>
            <span className="text-xs text-gray-500">
              {editData.images ? editData.images.length : 0}/3 images uploaded
            </span>
          </>
        )}
      </label>
    </div>
  </div>
) : (

                  <div className="mt-2 flex flex-col items-center">
                    {/* Standard single image for other designs */}
                    {editData.image ? (
                      <div className="relative mb-4">
                        <img src={editData.image} alt="Preview" className="max-h-40 object-contain rounded" />
                        <button 
                          onClick={() => setEditData({...editData, image: ""})}
                          className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-1 hover:bg-red-600"
                        >
                          <X size={16} />
                        </button>
                      </div>
                    ) : null}
                    
                    <div className="border-2 border-dashed border-gray-300 rounded-md p-6 w-full text-center hover:bg-gray-50 transition duration-150 cursor-pointer">
                      <input 
                        type="file" 
                        accept="image/*" 
                        onChange={handleImageUpload}
                        className="hidden" 
                        id="image-upload"
                        disabled={isUploading}
                      />
                      <label htmlFor="image-upload" className={`cursor-pointer ${isUploading ? 'opacity-50' : ''}`}>
                        {isUploading ? (
                          <div className="flex flex-col items-center">
                            <svg className="animate-spin h-8 w-8 text-blue-500 mb-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                            <span className="text-sm font-medium text-gray-700">Uploading...</span>
                          </div>
                        ) : (
                          <>
                            <Image className="mx-auto h-12 w-12 text-gray-400" />
                            <span className="mt-2 block text-sm font-medium text-gray-700">
                              {editData.image ? "Replace image" : "Click to upload an image"}
                            </span>
                          </>
                        )}
                      </label>
                    </div>
                  </div>
                )}
              </div>
              
              {/* Bullet Points */}
              <div>
                <label className="block font-medium text-gray-700 mb-2 flex items-center">
                  <List size={16} className="mr-2" /> 
                  {editData.design.layout === "arch-objectives" 
                    ? "Additional Headings & Descriptions (for Arch 2 & 3)" 
                    : "Bullet Points"}
                </label>
                {editData.design.layout === "arch-objectives" && (
                  <div className="mb-4 text-sm text-gray-500">
                    For Arch Objectives: Add headings and descriptions as bullet points in this order:<br/>
                    1. Arch 2 Heading, 2. Arch 2 Description, 3. Arch 3 Heading, 4. Arch 3 Description
                  </div>
                )}
                
                {/* Current Bullet Points */}
                {editData.bulletPoints && editData.bulletPoints.length > 0 ? (
                  <ul className="mb-4 space-y-2">
                    {editData.bulletPoints.map((point, index) => (
                      <li key={index} className="flex items-center bg-gray-50 p-2 rounded-md">
                        <span className="flex-grow">{point}</span>
                        <button 
                          onClick={() => handleRemoveBulletPoint(index)}
                          className="text-red-500 hover:text-red-700 ml-2"
                        >
                          <X size={16} />
                        </button>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p className="text-gray-500 italic mb-4">No bullet points added yet.</p>
                )}





                {/* Add New Bullet Point */}
                <div className="flex">
                  <input
                    type="text"
                    className="flex-grow border border-gray-300 rounded-l-md px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    value={newBulletPoint}
                    onChange={(e) => setNewBulletPoint(e.target.value)}
                    placeholder="Add a new bullet point"
                    onKeyPress={(e) => e.key === 'Enter' && handleAddBulletPoint()}
                  />
                  <button
                    onClick={handleAddBulletPoint}
                    className="bg-blue-500 text-white px-4 rounded-r-md hover:bg-blue-600 flex items-center"
                  >
                    <Plus size={16} className="mr-1" /> Add
                  </button>
                </div>


                {/* Draggable Slide Numbers */}
<div className="bg-gray-100 p-4 overflow-x-auto">
  <div className="flex justify-center space-x-2">
    {slides.map((slide, index) => (
      <button
        key={index}
        onClick={() => setCurrentSlide(index)}
        draggable
        onDragStart={(e) => {
          e.dataTransfer.setData('text/plain', index);
          e.currentTarget.classList.add('opacity-50');
        }}
        onDragEnd={(e) => {
          e.currentTarget.classList.remove('opacity-50');
        }}
        onDragOver={(e) => {
          e.preventDefault();
        }}
        onDrop={(e) => {
          e.preventDefault();
          const draggedIndex = parseInt(e.dataTransfer.getData('text/plain'));
          if (draggedIndex !== index) {
            handleReorderSlides(draggedIndex, index);
          }
        }}
        className={`w-10 h-10 rounded-full flex items-center justify-center cursor-move
          ${currentSlide === index 
            ? 'bg-blue-500 text-white font-bold' 
            : 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-50'
          } transition-colors`}
      >
        {index + 1}
      </button>
    ))}
  </div>
</div>

              </div>
            </div>
            
            <div className="border-t p-4 flex justify-end space-x-3">
              <Button color="gray" onClick={handleCloseEdit}>Cancel</Button>
              <Button onClick={handleSaveChanges} className="flex items-center">
                <Save size={16} className="mr-2" /> Save Changes
              </Button>

              <button
  onClick={() => handleAddSlide("Full Image")}
  className="ml-4 bg-green-500 text-white px-4 py-2 rounded-md hover:bg-green-600 flex items-center"
>
  <Plus size={16} className="mr-1" /> Add Image Slide
</button>
            </div>
          </div>
        </div>
      )}
    </div>
    </div>
  );
};

export default SellPage;









